export const locale = {
  general_menu_settings: 'Общие настройки меню',
  settings: {
  business_type_title: 'Выберите тип бизнеса для меню',
  currency_label: 'Валюта',
  show_filter: 'Показать фильтр продуктов',
  show_categories: 'Показать категории продуктов',
  
  business_types: {
    cafe: 'Кафе',
    restaurant: 'Ресторан',
    fastfood: 'Фаст-фуд',
    icecream: 'Соки и мороженое',
    sweets: 'Сладости и десерты',
    bakery: 'Пекарня'
  },
  
  custom_labels: {
        ph_menu_cafe: 'Меню кафе',
    ph_menu_restaurant: 'Меню еды',
    ph_menu_fastfood: 'Меню фастфуда',
    ph_menu_icecream: 'Соки и мороженое',
    ph_menu_sweets: 'Торты и сладости',
    ph_menu_bakery: 'Хлеб и выпечка',
    ph_product_list: 'Продукты',
    ph_add_order: 'Добавить',
    ph_add_cart: 'Купить',

    title: 'Настроить метки (Необязательно)',
    subtitle: 'Замените системные термины по умолчанию своими словами.',
    products_title: 'Заголовок раздела продуктов',
    ph_food_menu: 'напр. Меню еды',
    ph_product_list: 'напр. Список продуктов',
    cart_btn: 'Текст кнопки оформления заказа',
    ph_add_order: 'напр. Добавить к заказу',
    ph_add_cart: 'напр. Добавить в корзину'
  },

  currencies: {
    toman: 'Томан',
    rial: 'Риал'
  }
},
check_account_balance_and_try_again: 'Проверьте баланс своего счёта и попробуйте снова',
problem_with_qr_renewal_request: 'Возникла проблема при запросе на продление QR-кода',

  ERRORS: {
    PhoneIsNotValid: "Введен неверный номер телефона: напр. 09101234567",
    InvalidNumber: "Введено неверное количество.",
    NoSelectedLineNumber: "Пожалуйста, выберите линию отправителя.",
    EmptyText: "Пожалуйста, введите текст.",
    UnknownError: "Неизвестная ошибка",
    TryAgain: "Пожалуйста, попробуйте позже.",
    NoAccountCharge: "Недостаточно средств",
    NoAccess: "Нет доступа.",
    PleasebyeAPlane: "Пожалуйста, купите тарифный план.",
    PleaseChargeYourAccount: "Пожалуйста, пополните ваш счет.",
    AccessDenied: "Доступ запрещен.",
    AccessDeniedDescription:
      "Свяжитесь с поддержкой для получения дополнительной информации.",
    Error: "Ошибка",
    InvalidText: "Недопустимый текст",
    InvalidTextContainsLink: "Только сервисные линии могут содержать ссылки.",
    NoPhoneToSend: "Нет номеров для отправки.",
  },
  FORMS: {
    SuccsessFullySended: "Понятно",
    DestinationPhone: "Номер телефона получателя",
    TestDestinationPhone: "Тестовый номер телефона",
    SourceNumber: "Номер отправителя",
    Text: "Текст",
    CharCount: "Количество символов",
    FarsiCharCount: "Количество персидских символов",
    EnglishCharCount: "Количество английских символов",
    Send: "Отправить",
    SendTime: "Время отправки",
    SendTest: "Тестовая отправка",
    SendToTestNumber: "Отправить на тестовый номер",
    SmsCount: "Количество SMS",
    SmsLang: "Язык SMS",
    Add: "Добавить",
    FromFile: "Добавить из файла",
    TestNumber: "Тестовый номер",
    Test: "Тест",
    ServiceRelated: "Сервисный",
    Price: "Стоимость отправки по белому списку",
    TotalPrice: "Итоговая стоимость",
    NumbersCount: "Общее количество номеров",
    BlacklistPrice: "Стоимость отправки по черному списку",
    BlacklistNumbersCount: "Количество в черном списке",
    WhitelistNumbersCount: "Количество в белом списке",
    IrancellNumbersBlacklistCount: "Количество в черном списке Irancell",
    HamrahavalNumbersBlacklistCount: "Количество в черном списке Hamrah Aval",
    IrancellNumbersWhitelistCount: "Количество в белом списке Irancell",
    HamrahavalNumbersWhitelistCount: "Количество в белом списке Hamrah Aval",
    NumbersCountToSend: "Количество действительных номеров",
    Search: "Поиск",
    Title: "Название",
    RequestTime: "Время запроса",
    RequestInformation: "Информация о запросе",
    CreateNewPhoneBook: "Создать новую телефонную книгу",
    AddPhone: "Добавить номера",
    Remove: "Удалить",
  },
  unexpected_error:
    "Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова.",
  luck_wheel_name: "Название QR колеса удачи",
  update_video: "Добавить видеогалерею",
  edit: "Редактировать",
  to_top: "Сверху",
  to_bottom: "Снизу",
  to_left: "Справа налево",
  to_right: "Слева направо",
  to_top_right: "Снизу направо",
  to_top_left: "Снизу налево",
  to_bottom_right: "Сверху направо",
  to_bottom_left: "Сверху налево",
  select_color_gradient: "Выбрать градиент",
  select_color_solid: "Выбрать сплошной цвет",
  gradient_direction: "Направление градиента",
  gradient_background: "Градиентный фон",
  qr_downloaded_successfully: "QR успешно загружен.",
  logo: "Логотип",
  qr_design_size: "Дизайн и размер QR",
  qr_eye_design: "Дизайн глаз QR",
  qr_markout: "Отступ вывода",
  frame: "Рамка",
  ready_card_samples: "Готовые образцы визиток",
  ready_card_sample: "Готовый образец визитки",
  remove_default_info: "Удалить стандартные данные",
  select_ready_card: "Выбрать готовую визитку",
  connection_code: "Код подключения",
  enter_visit_card_info: "Введите данные визитки",
  info: "Информация",
  select_template_design: "Выбрать дизайн шаблона",
  qr_address: "Адрес QR",
  visit_card_name: "Название вашей визитки",
  visit_card_name_pro: "Название вашей визитки PRO",
  download_qr: "Скачать QR",
  fast_design: "Быстрый дизайн",
  professional_design: "Профессиональный дизайн",
  ai_design: "Дизайн ИИ",
  update_qr: "Обновить QR",
  fast_design_message:
    "Вы перешли к быстрому дизайну кода. Предыдущий дизайн был выполнен в этом разделе.",
  professional_design_message:
    "Вы перешли к профессиональному дизайну кода. Предыдущий дизайн был выполнен в этом разделе.",
  scan_me: "Отсканируй меня",
  visit_card_edited_successfully: "Ваша визитка успешно отредактирована.",
  customer_club_membership: "Членство в клубе клиентов",
  qrland: "QR Land",
  dynamic: "Динамический",
  about_us_text:
    "Особенности динамического QR-кода:\n✔️ Неограниченное редактирование\n✔️ Легкое сканирование\n✔️ Ограничение сканирований\n✔️ Добавление пароля\n✔️ Просмотр статистики посетителей\n✔️ Изменение цвета и внешнего вида\n✔️ Сохранение данных и безопасность\n✔️ Добавление фото и логотипа\n✔️ Специализированный QR по потребности\n✔️ Перенаправление на ссылки и сайт\n✔️ QR + короткая ссылка вместе\n✔️ Работает во всех соцсетях (оффлайн/онлайн)\n✔️ Скачивание в любом формате\n✔️ Печать на любой поверхности и размере",
  video_gallery: "Видеогалерея",
  address_text: "Москва, ул. Тверская, д. 6, корп. 6",
  visit_card: "Визитка",
  qrland_system: "Система QR Land",
  qrland_first_system: "Первая система создания динамических QR-кодов",
  address: "Адрес",
  enter_site_link: "Введите желаемую ссылку на сайт",
  instagram: "Instagram",
  enter_instagram_username: "Введите ваше имя пользователя",
  whatsapp: "WhatsApp",
  invalid_qr_address: "Введённый адрес неверный!",
  visit_card_created_successfully: "Ваша визитка успешно создана.",
  qr_creation_failed: "Ошибка при создании QR!",
  manage_password: "Управление паролем",
  hour_limit: "Ограничение по времени",
  scan_click_limit: "Ограничение сканирований/кликов",
  redirect_scanner: "Перенаправление сканера",
  edit_settings_error: "Ошибка при редактировании настроек!",
  next: "Далее",
  add: "Добавить",
  header_color_settings: "Настройки цвета и текста заголовка",
  select_image: "Выбрать изображение",
  enter_qr_address: "Введите ваш QR-адрес",
  qr_idea_title: "Идея создания QR",
  qr_idea: "Идея QR",
  qr_idea_subject: "Тема создания QR",
  confirm_qr_idea: "Подтвердить мою идею QR",
  scannable: "Сканируемый",
  ai_sample: "Пример, созданный ИИ...",
  scan_warning:
    "Может не сканироваться на всех устройствах. При неудаче попробуйте снова.",
  ai_description: "Опишите желаемый QR, ИИ создаст его для вас.",
  attach: "Прикрепить",
  remaining: "Осталось",
  qr_creation: "Создание QR",
  free: "Бесплатно",
  select_language_for_request: "Выбрать язык для текста запроса",
  request_text: "Текст запроса",
  request_text_placeholder: "Опишите желаемую QR-ссылку...",
  strengthen_text: "Усилить существующий текст",
  prompt_idea: "Идея промпта",
  try_again: "Попробовать снова",
  create_qr: "Создать QR",
  smart_qr_code: "Умный QR-код",
  regenerate_image: "Перегенерировать изображение",
  updating_qr: "Обновление QR...",
  copied: "Скопировано",
  copy: "Копировать",
  print_qr: "Печать QR",
  print_visit_card: "Печать визитки",
  send_link: "Отправить ссылку",
  customer_list: "Список клиентов",
  order_list: "Список заказов",
  reserved_appointments: "Забронированные встречи",
  feedback: "Обратная связь",
  request_form: "Форма заявки",
  transfer_ownership: "Передать право собственности",
  select_nfc_card: "Выбрать NFC-карту",
  created_at: "Создано",
  last_edit: "Последнее изменение",
  qr_card: "QR-карта",
  viewed: "Просмотрено",
  see_more: "Показать больше",
  download: "Скачать",
  activate: "Активировать",
  design: "Дизайн",
  qr_settings: "Настройки QR",
  deactivate: "Деактивировать",
  qr_color_size: "Цвет и размер QR",
  dots_design_color: "Дизайн и цвет точек",
  eye_design_color: "Дизайн и цвет глаз",
  border_design_color: "Дизайн и цвет рамки",
  logo_settings: "Настройки логотипа",
  download_qr_comment: "Скачать QR",
  connection_established: "Соединение установлено.",
  show_qr: "Показать QR",
  preview: "Предпросмотр",
  user_info: "Информация о пользователе",
  sms_club_membership: "Членство в SMS-клубе",
  smart_settings: "Умные настройки",
  add_audio_file: "Добавить аудиофайл",
  back: "Назад",
  after_click_location:
    "После клика на местоположение выберите ваше приложение карт.",
  phone_number: "Номер телефона",
  auto_display: "Автопоказ",
  customer_club: "Клуб клиентов",
  auto_download: "Автозагрузка",
  save: "Сохранить",
  about_us: "О нас",
  view_more: "Показать больше",
  view_less: "Показать меньше",
  audio_file: "Аудиофайл",
  add_video: "Добавить видео",
  add_image: "Добавить изображение",
  select_color: "Выбрать цвет",
  header_color: "Текст заголовка",
  add_social_networks: "Добавить соцсети",
  format: "Формат",
  output_size: "Размер вывода",
  file_type: "Тип файла",
  default: "По умолчанию",
  qr_download_error: "Ошибка при скачивании QR. Попробуйте снова",
  header_color_text_settings: "Настройки цвета и текста заголовка",
  upload_catalog_images: "Загрузить изображения каталога / брошюры",
  delete: "Удалить",
  personal_domain: "Личный домен",
  no_domain_found: "Домен не найден!",
  enter_domain_address: "Пожалуйста, введите адрес вашего домена",
  dns_setup_note: "Не забудьте сначала настроить DNS сервера!",
  attention: "Внимание: ",
  dns_setup_instruction: "Для регистрации личного домена сначала настройте DNS",
  and: "и",
  setup_on_domain: "на вашем домене.",
  dns_change_time: "(Изменение DNS может занять до 24 часов)",
  add_domain: "Добавить домен",
  add_personal_domain: "Добавить личный домен",
  min_characters: "Минимальное количество символов",
  domain_format:
    "Домен сайта должен быть в формате https://terminalads.com или terminalads.com.",
  invalid_domain: "Введённый домен недействителен!",
  domain_added_successfully: "Ваш домен успешно добавлен",
  invalid_dns_settings: "Настройки DNS недействительны!",
  deleted_successfully: "Успешно удалено",
  location: "Местоположение",
  save_contact: "Сохранить контакт",
  search: "Поиск",
  data_fetch_error: "Ошибка при получении данных!",
  error: "Ошибка",
  view_qr: "Просмотр QR",
  qr_design: "Дизайн QR",
  register: "Зарегистрироваться",
  terminal_ads: "Терминал Реклама",
  manage_40_advertising_methods: "Управление 40 методами рекламы одновременно!",
  ms_khansari: "Г-жа Хансары",
  support: "Поддержка",
  comprehensive_advertising_system:
    "Единственная комплексная система анализа и управления онлайн-рекламой",
  terminal_ads_description:
    "Система Терминал Реклама гордится постоянной и эффективной связью с клиентами и пользователями, чтобы понимать их потребности и предлагать лучшие решения. Наш самый большой капитал — это наши лояльные клиенты и пользователи, а затем — команда экспертов, которая поддерживает компанию новыми идеями и современными технологиями.",
  please_enter_qr_address_correctly: "Пожалуйста, введите адрес QR правильно!",
  server_error: "Ошибка сервера!",
  please_enter_your_address: "Пожалуйста, введите ваш адрес",
  please_enter_instagram_address: "Пожалуйста, введите ваш адрес Instagram",
  please_enter_whatsapp_address: "Пожалуйста, введите ваш адрес WhatsApp",
  enter_information: "Ввод информации",
  dynamic_qr: "Динамический QR",
  coming_soon: "Скоро",
  qr_name: "Имя QR",
  for_default_address_leave_empty: "!Для стандартного адреса оставьте пустым",
  default_address: "Адрес по умолчанию",
  sms: "SMS",
  enter_number_without_zero: "Введите номер без 0.",
  number: "Номер",
  country_code: "Код страны:",
  sms_text: "Текст SMS",
  complete_sms_fields_correctly: "Пожалуйста, правильно заполните поля SMS!",
  qr_code_created_successfully: "Ваш QR-код успешно создан.",
  chat: "Чат",
  call: "Позвонить",
  please_enter_username: "Пожалуйста, введите имя пользователя.",
  username: "Имя пользователя",
  sample_menu: "Пример меню",
  online_menu_name: "Название вашего онлайн-меню",
  online_menu_name_short: "Онлайн-меню",
  enter_menu_information: "Введите информацию о меню",
  select_sample_menu: "Выберите пример меню",
  select_ready_menu: "Выберите готовое меню",
  online_sales: "Онлайн-продажи",
  sales_settings: "Настройки продаж",
  photo_gallery: "Фотогалерея",
  fast_food1: "Фастфуд 1",
  fast_food2: "Фастфуд 2",
  products: "Товары",
  pizzas: "Пиццы",
  pizza_rust_beef: "Пицца с жареной говядиной",
  italian_pizza_with_beef: "Итальянская пицца с говядиной",
  italian_pizza_dough_30cm: "Итальянское тесто для пиццы 30 см",
  "100g_shredded_beef": "100 г измельчённой говядины",
  mushroom_bell_pepper: "Грибы, болгарский перец",
  black_olives: "Чёрные оливки",
  pizza_chicken_mushroom: "Пицца с курицей и грибами",
  classic_40cm: "Классика 40 см",
  fresh_tomato_sauce:
    "Свежий томатный соус, сыр, куриное филе, грибы, горный тимьян",
  pizza_meat_mushroom: "Пицца с мясом и грибами",
  meat_pizza_with_mushroom: "Пицца с фаршем и грибами",
  pizza_vegetables: "Овощная пицца",
  american_vegetable_pizza: "Американская овощная пицца",
  american_pizza_dough:
    "Американское тесто для пиццы, кукуруза, грибы, оливки, помидоры, лук, перец, сыр",
  special_pizza: "Особая пицца",
  american_special_pizza: "Американская особая пицца",
  pizza_bolognese: "Пицца Болоньезе",
  one_person_23cm: "(1 человек) Тесто для пиццы 23 см",
  pepperoni_pizza: "Пицца Пепперони",
  one_person_23cm_dough: "(1 человек) Тесто для пиццы 23 см",
  bacon_pizza: "Пицца с беконом",
  one_person_23cm_explosion: "(1 человек) Тесто для пиццы 23 см",
  mixed_pizza: "Смешанная пицца",
  one_person_23cm_mixed: "(1 человек) Тесто для пиццы 23 см",
  american_steak_pizza: "Американская пицца со стейком",
  one_person_23cm_steak: "(1 человек) 23 см",
  burgers: "Бургеры",
  cheese_burger: "Чизбургер",
  with_french_fries: "с картофелем фри",
  "2_beef_burgers_150g": "2 говяжьих бургера по 150 г",
  special_sauce_gouda_cheese: "Особый соус, сыр Гауда",
  pickles_lettuce_tomato: "Огурцы, салат, помидор",
  special_sauce: "Особый соус",
  burger: "Бургер",
  pure_meat_with_special_sauce: "Чистое мясо с особым соусом",
  chicken_burger: "Куриный бургер",
  grilled_chicken_burger_with_cheese: "Гриль куриный бургер с сыром",
  spicy_burger: "Острый бургер",
  beef_with_spicy_sauce: "Говядина с острым соусом",
  double_burger: "Двойной бургер",
  "150g_beef": "Говядина 150 г",
  royal_burger: "Королевский бургер",
  "150g_beef_emoji": "150 г говядины",
  mushroom_burger: "Грибной бургер",
  "150g_beef_mushroom": "Говядина 150 г",
  mushroom_burger_grilled: "Грибной бургер",
  "100_percent_grilled_beef": "100 % говядина на гриле",
  fried_burger: "Жареный бургер",
  "100_percent_grilled_fried": "100 % говядина на гриле и жареная",
  fried: "Жареный",
  fried_chicken: "Жареная курица",
  "3_piece_fried_chicken": "3 куска жареной курицы",
  "3_fried_chicken_pieces": "3 куска жареной курицы",
  "120_150g_french_fries": "120-150 г картофеля фри",
  enter_product_information: "Введите информацию о товаре",
  product_name: "Название вашего товара",
  product_name_short: "Название товара",
  complete_features_from_image:
    "Заполните характеристики по изображению товара",
  skip_step: "Пропустить шаг",
  product_and_information: "Товар и информация",
  product_introduction: "Представление товара",
  shiva_waves: "Волны Шивы",
  think_best: "Думай лучше...",
  iran_zanjan_abhar:
    "Иран, Зенджан, Абхар, промышленная зона Шариф, рядом с подстанцией 63/20 кВ",
  video_gallery_description: "Смотрите наши видео.",
  gallery: "Галерея",
  welcome: "Добро пожаловать",
  invalid_address: "Введённый адрес недействителен!",
  product_created_successfully: "Ваш товар успешно создан.",
  qr_visit_card_edited_successfully:
    "Ваша визитная карточка успешно отредактирована.",
  change_header_color: "Изменить цвет заголовка",
  change_body_color: "Изменить цвет тела",
  change_button_colors: "Изменить цвета кнопок",
  change_text_colors: "Изменить цвета текста",
  gradient_colors: "Градиентные цвета",
  color_direction: "Направление цвета",
  first_color: "Первый цвет",
  second_color: "Второй цвет",
  color: "Цвет",
  text_color: "Цвет текста",
  from_top: "Сверху",
  from_bottom: "Снизу",
  from_left_to_right: "Слева направо",
  from_right_to_left: "Справа налево",
  from_top_to_left: "Сверху слева",
  from_top_to_right: "Сверху справа",
  from_bottom_to_left: "Снизу слева",
  from_bottom_to_right: "Снизу справа",
  sharing: "Поделиться",
  business_shop: "Бизнес / Магазин",
  corporate_organizational: "Компания / Организационная",
  customer_contact: "Контакт клиента",
  information: "Информация",
  miscellaneous: "Разное",
  link: "Ссылка",
  margin: "Отступ",
  width: "Ширина",
  height: "Высота",
  background_color: "Цвет фона",
  gradient_color: "Градиентный цвет",
  linear: "Линейный",
  radial: "Радиальный",
  color_rotation: "Поворот цвета",
  background_color_label: "Цвет фона",
  dots_color: "Цвет точек",
  dots_color_label: "Цвет точек",
  eye_colors: "Цвета глаз",
  separate_colors_for_each_eye: "Отдельные цвета для каждого глаза",
  current_mode: "Текущий режим:",
  separate_colors: "Отдельные цвета",
  same_color: "Один цвет",
  all_eyes_color: "Цвет всех глаз",
  top_right_eye: "Верхний правый глаз",
  top_left_eye: "Верхний левый глаз",
  bottom_left_eye: "Нижний левый глаз",
  upload_logo: "Загрузить логотип",
  hide_background_dots: "Скрыть точки за логотипом",
  logo_size: "Размер логотипа",
  logo_margin: "Отступ логотипа",
  qr_accuracy: "Точность QR",
  mode: "Режим",
  error_correction_level: "Уровень коррекции ошибок",
  numeric: "Числовой",
  alphanumeric: "Буквенно-цифровой",
  byte: "Байт",
  apply_changes: "Применить изменения",
  please_click_apply_changes:
    'Нажмите "Применить изменения" после выбора модификаций.',
  created_qr_codes: "Созданные QR-коды",
  square_ratio: "1:1 (квадрат)",
  image_upload_error: "Ошибка загрузки изображения!",
  visit_card_name_label: "Название визитной карточки",
  sms_membership_message: "SMS-сообщение о членстве в клубе клиентов",
  admin_menu: "Меню администратора",
  user_menu: "Меню пользователя",
  guide_tooltip: "Руководство",
  close: "Закрыть",
  browser_video_support_error:
    "Ваш браузер не поддерживает ни один видеоформат.",
  video_loading_error: "Ошибка загрузки видео (доступ может быть ограничен).",
  click_more_for_videos: "Нажмите «Ещё», чтобы увидеть больше видео.",
  more_info: "Больше информации",
  more: "Ещё",
  add_user_guide: "Добавить руководство пользователя",
  edit_user_guide: "Редактировать руководство пользователя",
  display_info: "Отображать информацию",
  element: "Элемент",
  disable_attach: "Отключить привязку для подгонки к странице",
  view: "Просмотр",
  guide: "Руководство",
  details: "Детали",
  guide_images: "Изображения руководства",
  guide_videos: "Видео руководства",
  faq: "Часто задаваемые вопросы",
  data_preload_error: "Ошибка предзагрузки данных:",
  guide_not_found: "Руководство не найдено. Сначала создайте руководство.",
  delete_guide_question: "Удалить руководство?",
  delete_guide_error: "Ошибка удаления руководства!",
  unknown_file_type: "Неизвестный тип файла:",
  content_type_error: "Ошибка получения типа содержимого:",
  video: "Видео",
  image: "Изображение",
  guide_data_error: "Ошибка получения данных руководства:",
  add_iranian_stores: "Добавить иранские магазины",
  add_foreign_stores: "Добавить зарубежные магазины",
  bazaar: "Базар",
  myket: "Майкет",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "Samsung Store",
  xiaomi_store: "Xiaomi Store",
  vivo_store: "Vivo Store",
  amazon_store: "Amazon Store",
  bazaar_app: "Приложение Базар",
  bazaar_link_placeholder: "Введите ссылку на приложение Базар",
  bazaar_link_hint:
    "Введите действительную ссылку Базар (например, https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "Приложение Майкет",
  myket_link_placeholder: "Введите ссылку на приложение Майкет",
  myket_link_hint:
    "Введите действительную ссылку Майкет (например, myket://details?id=com.example)",
  app_store_app: "Приложение App Store",
  app_store_link_placeholder: "Введите ссылку на приложение App Store",
  app_store_link_hint:
    "Введите действительную ссылку App Store (например, https://apps.apple.com/us/app/appname/id123456789)",
  google_play_app: "Приложение Google Play",
  google_play_link_placeholder: "Введите ссылку на приложение Google Play",
  google_play_link_hint:
    "Введите действительную ссылку Google Play (например, https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "Приложение Samsung Store",
  samsung_store_link_placeholder: "Введите ссылку на приложение Samsung Store",
  samsung_store_link_hint:
    "Введите действительную ссылку Samsung Store (например, https://galaxy.store/appname)",
  xiaomi_store_app: "Приложение Xiaomi Store",
  xiaomi_store_link_placeholder: "Введите ссылку на приложение Xiaomi Store",
  xiaomi_store_link_hint: "Введите действительную ссылку Xiaomi Store",
  vivo_app_store: "Vivo App Store",
  vivo_app_store_app: "Приложение Vivo App Store",
  vivo_app_store_link_placeholder:
    "Введите ссылку на приложение Vivo App Store",
  vivo_app_store_link_hint: "Введите действительную ссылку Vivo App Store",
  amazon_store_app: "Приложение Amazon Store",
  amazon_store_link_placeholder: "Введите ссылку на приложение Amazon Store",
  amazon_store_link_hint: "Введите действительную ссылку Amazon Store",
  iranian_store: "Иранский магазин",
  foreign_store: "Зарубежный магазин",
  personal_store: "Личный магазин",
  image_logo: "Изображение/Логотип",
  image_gallery: "Галерея изображений",
  header_image: "Изображение заголовка",
  template_background_image: "Фоновое изображение шаблона",
  background_image: "Фоновое изображение",
  background_image_alt: "Фоновое изображение",
  logo_upload: "Загрузить логотип",
  welcome_image: "Изображение приветствия",
  welcome_image_logo_upload: "Загрузить изображение/логотип приветствия",
  loading_animation: "Анимация загрузки",
  preview_welcome_page: "Предпросмотр страницы приветствия",
  max_background_size: "Максимальный размер фонового изображения: 2 МБ.",
  max_logo_size: "Максимальный размер логотипа: 2 МБ.",
  scale_from_center: "Масштабировать от центра",
  slide_from_left: "Скользить слева",
  slide_from_top: "Скользить сверху",
  fade: "Затухание",
  select_music_card: "Выберите музыкальную карточку",
  show_audio: "Показать аудио",
  hide_audio: "Скрыть аудио",
  add_voice: "Добавить голос",
  max_files_limit: "Вы не можете выбрать больше {count} файлов!",
  files_not_allowed: "Файлы не разрешены!",
  voice_gallery: "Голосовая галерея",
  edit_voice: "Редактировать голос",
  list: "Список",
  file_name: "Имя файла",
  title: "Заголовок",
  description: "Описание",
  selectdate: "Выбрать дату",
  background: "Фон",
  text: "Текст",
  delete_audio_confirm:
    "Вы уверены, что хотите удалить аудиофайл из вашей галереи?",
  add_voice_gallery: "Добавить голосовую галерею",
  gallery_number: "Галерея",
  delete_confirm: "Вы уверены, что хотите удалить?",
  confirm: "?",
  voice_gallery_title_hint: "Введите заголовок вашей голосовой галереи.",
  voice_gallery_title: "Заголовок",
  voice_gallery_subtitle_hint: "Введите подзаголовок вашей голосовой галереи.",
  voice_gallery_subtitle: "Подзаголовок голосовой галереи",
  voice_gallery_subtitle_alt: "Подзаголовок",
  website_address_hint: "Введите адрес вашего сайта.",
  website_address: "Адрес сайта",
  about_voice_gallery: "О галерее",
  about_voice_gallery_alt: "О галерее",
  button_name_hint: "Введите название кнопки.",
  button_name: "Название кнопки",
  domain_format_hint:
    "Домен должен быть https://terminalads.com или terminalads.com.",
  about_us_alt: "О нас",
  add_default_form: "Добавить форму по умолчанию",
  delete_all: "Удалить все",
  validation_active: "Валидация: Активна",
  validation_inactive: "Валидация: Неактивна",
  validation: "Валидация",
  clear_form: "Очистить форму",
  status: "Статус",
  active: "Активен",
  inactive: "Неактивен",
  optional: "Необязательно",
  required: "Обязательно",
  question_title: "Заголовок",
  question_title_hint: "Введите заголовок вопроса",
  options_hint: "Напишите варианты и нажмите Enter для добавления",
  options: "Варианты",
  add_suggested_form: "Добавить предложенную форму",
  save_changes: "Сохранить изменения",
  add_request_field: "Добавить поле запроса",
  select_form_type: "Выберите тип формы",
  select_form_type_placeholder: "Выберите тип формы",
  dropdown: "Выпадающий список",
  text_field: "Текстовое поле",
  number_field: "Числовое поле",
  textarea_field: "Текстовая область",
  date_field: "Поле даты",
  field_name_required: "Имя поля не может быть пустым",
  field_name: "Имя поля",
  add_field_name: "Добавить имя поля",
  field_label: "Метка поля",
  add_field_label: "Добавить метку поля",
  advanced_settings: "Расширенные настройки",
  select_input_pattern: "Выберите шаблон ввода",
  select_input_pattern_placeholder: "Выберите шаблон ввода",
  max_characters: "Максимум символов",
  min_input_error: "Минимальный ввод должен быть 0",
  name_field: "Имя",
  field_type: "Тип поля",
  persian_limit: "Ограничение персидского языка",
  family_name: "Фамилия",
  mobile_number: "Мобильный номер",
  number_limit: "Ограничение чисел",
  national_code: "Национальный код",
  meli_code: "Национальный код",
  email: "Электронная почта",
  email_limit: "Ограничение email",
  dropdown_field: "Поле выпадающего списка",
  english_limit: "Ограничение английского языка",
  mix_per_eng_limit: "Ограничение смеси персидского и английского",
  site_limit: "Ограничение сайта",
  form_added_successfully: "Новая форма успешно добавлена",
  form_updated_successfully: "Форма успешно обновлена",
  delete_item_confirm: "Вы уверены, что хотите удалить элемент?",
  default_form_added_successfully: "Форма по умолчанию успешно добавлена",
  resources_upload_error: "Ошибка загрузки ресурсов",
  update_value_if_duplicate: "Обновить значение, если дублируется",
  first_tab: "Первая вкладка",
  display_count: "Количество отображаемых",
  buy_renew_qr_instruction:
    "Чтобы купить/продлить QR, нажмите кнопку срока действия.",
  days_until_expiry: "Дней до истечения",
  expired: "Истёк",
  no_qr_to_display: "Нет QR для отображения!",
  second_tab: "Вторая вкладка",
  total_qr_codes: "Всего QR-кодов",
  select_all: "Выбрать все",
  selected_qr_codes_count: "Количество выбранных QR-кодов",
  qr_codes_count: "Количество QR-кодов",
  group_renewal_instruction:
    "Для группового продления выберите нужные QR-коды.",
  no_qr_found_with_filters: "QR с этими фильтрами не найдены!",
  qr_codes_count_label: "Количество QR-кодов:",
  renew_qr: "Продлить QR",
  days: "Дней",
  buy_now: "Купить сейчас!",
  buy_now_label: "Купить",
  add_discount_code: "Добавить код скидки",
  use_discount_code: "Использовать код скидки",
  discount_code: "Код скидки",
  submit: "Отправить",
  my_qr_list: "Мой список QR",
  group_renewal: "Групповое продление",
  row: "Строка",
  type: "Тип",
  clicks: "Клики",
  created_at_diff: "Время создания",
  updated_at_diff: "Время обновления",
  table_view: "Табличный вид",
  normal_view: "Обычный вид",
  no_qr_or_id_selected: "QR или ID не выбраны!",
  qr_updated_successfully: "QR успешно обновлён.",
  qr_update_error: "Ошибка обновления QR!",
  no_qr_selected: "QR не выбран!",
  no_qr_code_selected: "QR-код не выбран!",
  success: "Успех",
  qrs_upgraded_successfully: "Ваши QR успешно обновлены.",
  qr_renewal_error: "Проблема с запросом продления QR!",
  changed_successfully: "Успешно изменено.",
  error_occurred: "Произошла ошибка!",
  no_tariff_exists: "Тариф не существует!",
  qr_upgraded_successfully: "Ваш QR успешно обновлён.",
  check_account_balance: "Проверьте баланс аккаунта и попробуйте позже.",
  group_renewal_price_error: "Ошибка получения цены группового продления!",
  qr_count_error: "Ошибка получения количества QR!",
  no_qr_for_renewal: "Нет QR для продления!",
  table_pagination: "Пагинация таблицы",
  virtual_scroll_display: "Отображение виртуальной прокрутки",
  popups_shared_components: "Всплывающие окна и общие компоненты",
  edit_qr_address: "Редактировать адрес QR",
  please_enter_correct_address: "Пожалуйста, введите правильный адрес",
  successfully_edited: "Успешно отредактировано.",
  error_editing_qr_address: "Ошибка редактирования адреса QR!",
  go_to_page: "Перейти на страницу",
  page_from_to: "Страница {current} из {last}",
  display: "Отображать",
  to: "до",
  from: "от",
  show: "Показать",
  page_status: "Страница {current} из {total}",
  until: "до",
  successfully_completed: "Успешно завершено",
  problem_occurred: "Возникла проблема",
  download_failed: "Скачивание не удалось",
  audio_file_default: "Аудиофайл",
  memory_release: "Освобождение памяти",
  seek_music_comment: "Например, эта музыка или что-то ищущее",
  all: "Все",
  create_podcast: "Создать подкаст",
  add_link: "Добавить ссылку",
  upload_file: "Загрузить файл",
  file_list: "Список файлов",
  count: "Количество",
  select_category: "Выберите категорию",
  after_typing_enter: "После ввода нажмите Enter.",
  no_image_available: "Изображение недоступно",
  no_image_found: "Изображение не найдено!",
  for_adding_file_use_upload_center:
    "Чтобы добавить файл, используйте поле загрузки или центр загрузки",
  ai_story_creation_description: "Введите вашу историю, ИИ создаст её для вас",
  create_new_podcast: "Создать новый подкаст",
  show_audio_file: "Показать аудиофайл",
  cancel: "Отмена",
  no_audio_in_category: "В этой категории нет аудиофайлов",
  health_apple: "Яблоко здоровья",
  standard: "Стандарт",
  arshia_badge: "Значок Аршия",
  home_appliances_association: "Ассоциация бытовой техники",
  energy_label: "Энергетическая метка",
  select_gold_purity_first:
    "Чтобы получить цену, сначала выберите чистоту золота",
  gold_price_service: "Сервис цены золота",
  rahvard: "Рахвард",
  to_change_gold_service_go_to_assets:
    "Чтобы изменить сервис цены золота, перейдите в раздел активов",
  gold: "Золото",
  purity: "Чистота",
  rial: "Риал",
  final_product_price: "Окончательная цена товара",
  show_images_right_side: "Показывать изображения справа",
  show_as_slider: "Показывать как слайдер.",
  show_as_grid: "Показывать как сетку.",
  show_as_second_mode: "Показывать как второй режим.",
  gallery_name: "Название галереи",
  change_gallery_name: "Изменить название галереи",
  add_photo: "Добавить фото",
  select_photo: "Выбрать фото",
  show_image: "Показать изображение",
  selected_photo: "Выбранное фото",
  to_use_ready_images_search_category_or_product:
    "Чтобы использовать готовые изображения, ищите категорию или товар выше.",
  max_file_size_2mb: "Максимальный размер файла: 2 МБ.",
  drag_and_drop_to_upload_or: "Перетащите для загрузки или",
  here: "здесь",
  click: "нажмите",
  to_use_external_image_link_fill_fields:
    "Чтобы использовать внешнюю ссылку на изображение, заполните поля ниже",
  image_url_hint: "URL желаемого изображения (ссылка).",
  image_url: "Ссылка на изображение",
  add_new_gallery: "Добавить новую галерею",
  create_image: "Создать изображение",
  ready_images: "Готовые изображения",
  edit_image: "Редактировать изображение",
  enter_valid_link: "Введите действительную ссылку.",
  max_background_image_size_2mb:
    "Максимальный размер фонового изображения: 2 МБ.",
  uploaded_successfully: "Успешно загружено.",
  banner: "Баннер",
  question: "Вопрос",
  selected_question: "Выбранный вопрос",
  answer: "Ответ",
  add_question: "Добавить вопрос",
  selected_blog: "Выбранный блог",
  icon: "Иконка",
  select_icon: "Выбрать иконку",
  add_blog: "Добавить блог",
  post: "Пост",
  selected_services: "Выбранные услуги",
  add_new_post: "Добавить новый пост",
  add_new_services: "Добавить новые услуги",
  add_new_service: "Добавить новую услугу",
  domain_must_be_https_or_http:
    "Домен должен быть https://terminalads.com или terminalads.com.",
  id: "ID",
  images: "Изображения",
  tags: "Теги",
  print_type: "Тип печати",
  user: "Пользователь",
  user_shipping_info: "Информация о доставке пользователя",
  qr_short_link: "Короткая ссылка QR",
  delivery_method: "Способ доставки",
  delivery_at_company: "Доставка в компанию",
  delivery_by_post: "Доставка почтой",
  post_cost_and_tax_warning:
    "При регистрации почтовые расходы и 10% налог будут вычтены из вашего кошелька.",
  shipping_info: "Информация о доставке",
  continue_shopping: "Продолжить покупки",
  complete_shopping: "Завершить покупку",
  select_free_nfc_card: "Выберите бесплатную NFC-карту",
  order_custom_nfc_card: "Заказать пользовательскую NFC-карту",
  buy_qr_equipment: "Купить оборудование QR",
  vertical: "Вертикальный",
  horizontal: "Горизонтальный",
  card_type: "Тип карты",
  tag: "Тег",
  select: "Выбрать",
  order_card: "Заказать карту",
  available: "Доступно",
  unavailable: "Недоступно",
  for_initial_loading: "Для начальной загрузки",
  already_have_free_nfc_message:
    "Вы уже получили бесплатную NFC для этого QR. Чтобы изменить, купите пользовательскую карту.",
  nfc_in_delivery_process_message:
    "Вы уже зарегистрировали бесплатную NFC, которая в пути. Чтобы изменить, купите пользовательскую.",
  free_nfc_card_warning_message:
    "Уважаемый пользователь: Бесплатные NFC-карты предварительно напечатаны, ваш QR меняется. Если используется, купите пользовательскую.",
  select_card: "Выберите карту",
  free_card_selection_conditions: "Условия выбора бесплатной карты",
  confirm_and_select: "Подтвердить и выбрать",
  registered_successfully: "Успешно зарегистрировано.",
  error_registering_nfc_order: "Ошибка регистрации заказа NFC-карты!",
  nfc_physical_card_orders: "Заказы физических NFC-карт",
  buy_equipment: "Купить оборудование",
  select_quantity: "Выберите количество",
  ready_samples: "Готовые образцы",
  upload_custom_design: "Загрузить пользовательский дизайн",
  select_ready_card_image: "Выберите готовое изображение карты",
  select_card_front_image: "Выберите изображение лицевой стороны карты",
  select_card_back_image: "Выберите изображение обратной стороны карты",
  nfc_card_image: "Изображение NFC-карты",
  add_quantity: "Добавить количество",
  total_price: "Общая цена",
  price_with_discount: "Цена со скидкой",
  shipping_cost: "Стоимость доставки",
  your_profit_from_purchase: "Ваша прибыль от покупки",
  discount: "Скидка",
  ten_percent_tax_will_be_added: "К итоговой сумме будет добавлен 10% налог.",
  payable_amount: "Сумма к оплате",
  continue: "Продолжить",
  Confirm_code: "Код подтверждения",
  form_success_message: "Ваша форма успешно отправлена",
  refill_form_message: "Пожалуйста, заполните форму заново",
  Enter_the_sent_code: "Введите отправленный вам код",
  SUBMIT_FORM: "Отправить форму",
  enter_phone_number: "Введите ваш мобильный номер",
  order_registered_successfully: "Ваш заказ успешно зарегистрирован.",
  smart_creation: "Умное создание",
  automatic_creation: "Автоматическое создание",
  business_name: "Название бизнеса",
  example_household_goods: "Пример: бытовые товары",
  organization_name: "Название организации",
  example_tech_company: "Пример: компания передовых технологий",
  minimum_two_characters_required: "Требуется минимум два символа!",
  maximum_100_characters_allowed: "Максимум 100 символов",
  latin_name_qr_address: "Латинское имя (адрес QR)",
  example_advanced_tech: "Пример: advanced-tech",
  only_english_numbers_dash_allowed:
    "Разрешены только английские буквы, цифры и дефис",
  maximum_50_characters_allowed: "Максимум 50 символов",
  latin_name_goes_after_domain: "Латинское имя идёт после домена",
  select_logo_and_store_product_image:
    "Выберите логотип и изображение магазина/товара",
  select_logo: "Выберите логотип",
  file_size_must_be_less_than_2mb: "Размер файла должен быть менее 2 МБ",
  for_buying_renewing_qr_click_expiry_button:
    "Чтобы купить/продлить QR, нажмите кнопку срока действия.",
  for_group_renewal_select_desired_qr_codes:
    "Для группового продления выберите нужные QR-коды.",
  no_qr_found_with_these_filters: "QR с этими фильтрами не найдены!",
  i_buy: "Покупаю",
  visits: "Посещения",
  creation_time: "Время создания",
  edit_time: "Время редактирования",
  enter_business_card_name_correctly:
    "Введите название визитной карточки правильно!",
  are_you_sure_delete_qr: "Вы уверены, что хотите удалить QR?",
  qr_deleted_successfully: "QR успешно удалён.",
  are_you_sure_deactivate_qr: "Вы уверены, что хотите деактивировать QR?",
  are_you_sure_activate_qr: "Вы уверены, что хотите активировать QR?",
  deactivated: "Деактивирован",
  qr_successfully: "QR успешно",
  successfully: "Успешно",
  user_transferred_successfully: "Пользователь успешно перенесён",
  problem_occurred_in_transfer: "Проблема при переносе!",
  error_in_user_transfer: "Ошибка переноса пользователя!",
  qr_business_card_edited_successfully:
    "Ваша визитная карточка успешно отредактирована.",
  group_qr_renewal: "Групповое продление QR",
  select_desired_duration: "Выберите желаемый срок",
  total_count: "Общее количество",
  final_amount: "Итоговая сумма",
  ten_percent_vat_will_be_added: "К сумме выше будет добавлен 10% НДС.",
  pay_and_upgrade: "Оплатить и обновить",
  no_tariff_for_this_period: "Тариф за этот период отсутствует!",
  selected: "Выбрано",
  total_amount: "Общая сумма",
  final_amount_with_discount: "Итоговая сумма со скидкой",
  add_qr: "Добавить QR",
  actions: "Действия",
  filter_type: "Фильтр типа",
  start_from: "Начать с",
  search_in_id: "Поиск по ID",
  filter_user: "Фильтр пользователя",
  clear_filters: "Очистить фильтры",
  send_sms: "Отправить SMS",
  selected_pattern: "Выбранный шаблон",
  send: "Отправить",
  bulk_download: "Массовое скачивание",
  one_month_renewal: "Продление на один месяц",
  three_month_renewal: "Продление на три месяца",
  six_month_renewal: "Продление на шесть месяцев",
  one_year_renewal: "Продление на один год",
  no_item_selected: "Элемент не выбран!",
  error_loading_card_info: "Ошибка загрузки информации о карте!",
  send_registered_successfully: "Отправка успешно зарегистрирована",
  error_getting_prices: "Ошибка получения цен!",
  payment_error: "Ошибка оплаты!",
  business_card: "Визитная карточка",
  product_label: "Метка товара",
  restaurant_menu: "Меню ресторана",
  event_ticket: "Билет на мероприятие",
  brochure: "Брошюра",
  flyer: "Флаер",
  poster: "Плакат",
  catalog: "Каталог",
  newsletter: "Информационный бюллетень",
  organization_name_hint: "Введите название вашей организации.",
  organization_name_label: "Название организации",
  sub_organization_hint: "Введите название подорганизации.",
  sub_organization_label: "Описание подорганизации",
  user_name_hint: "Введите ваше имя.",
  user_name_label: "Имя и фамилия",
  work_field_hint: "Введите вашу должность.",
  work_field_label: "Должность",
  mobile_number_hint: "Введите ваш номер.",
  mobile_number_label: "Мобильный номер",
  phone_number_hint: "Введите номер телефона.",
  phone_number_label: "Номер телефона",
  email_hint: "Введите ваш email.",
  email_label: "Email",
  fax_hint: "Введите факс компании.",
  fax_label: "Факс компании",
  website_hint: "Введите сайт компании.",
  website_label: "Сайт компании",
  postal_code_hint: "Введите почтовый индекс.",
  postal_code_label: "Почтовый индекс",
  copyright_hint: "Введите текст авторских прав в футере.",
  copyright_label: "Текст авторских прав",
  address_hint: "Введите ваш адрес.",
  address_label: "Адрес",
  add_more_info: "Добавьте больше информации, которую хотите:",
  edit_location: "Редактировать",
  add_location: "Добавить",
  delete_location: "Удалить местоположение",
  about_us_label: "О нас",
  search_address: "Поиск адреса:",
  northern_coordinates: "Северные координаты",
  eastern_coordinates: "Восточные координаты",
  select_address_on_map: "Выберите адрес на карте",
  location_not_found: "Местоположение не найдено.",
  text_label: "Текст",
  number_label: "Число",
  website_address_label: "Адрес сайта",
  location_label: "Местоположение",
  mobile_viewer_title: "Мобильный просмотрщик",
  visit_theme_two_title: "Тема визитной карточки 2",
  visit_theme_flipped_title: "Перевёрнутая тема визитной карточки",
  flip_card: "Перевернуть карточку",
  flip_card_description:
    "Чтобы увидеть больше информации, переверните карточку",
  share_contacts: "Поделиться контактами",
  close_share: "Закрыть обмен",
  card_front: "Лицевая сторона карточки",
  card_back: "Обратная сторона карточки",
  flip_to_back: "Перевернуть назад",
  flip_to_front: "Перевернуть вперёд",
  swipe_to_flip: "Свайпните, чтобы перевернуть",
  swipe_left: "Свайп влево",
  swipe_right: "Свайп вправо",
  expand_card: "Развернуть карточку",
  contract_card: "Свернуть карточку",
  view_details: "Посмотреть детали",
  hide_details: "Скрыть детали",
  social_media_share: "Обмен в социальных сетях",
  contact_actions: "Действия контакта",
  card_actions: "Действия карточки",
  floating_menu: "Плавающее меню",
  close_menu: "Закрыть меню",
  open_menu: "Открыть меню",
  choice_gallery: "Выбранная галерея",
  choice_video: "Выбрать видео",
  url_video: "Ссылка на видео",
  selected_video: "Выбранное видео",
  add_video: "Добавить видео",
  edit_video: "Редактировать видео",
  linl_video: "Ссылка передачи",
  upload_video: "Загрузить видео",
  rule_link: "Домен должен быть https://terminalads.com или terminalads.com.",
  fax_hint: "Введите факс компании.",
  fax_label: "Факс компании",
  website_hint: "Введите сайт компании.",
  website_label: "Сайт компании",
  postal_code_hint: "Введите почтовый индекс.",
  postal_code_label: "Почтовый индекс",
  add_more_info: "Добавьте больше информации, которую хотите:",
  address_hint: "Введите ваш адрес.",
  address_label: "Адрес",
  edit_location: "Редактировать",
  add_location: "Добавить",
  delete_location: "Удалить местоположение",
  location_label: "Местоположение",
  about_company_label: "О компании",
  select_address_on_map: "Выберите адрес на карте",
  search_address: "Поиск адреса:",
  rule_link: "Домен должен быть https://terminalads.com или terminalads.com.",
  link_label: "Адрес ссылки",
  label_label: "Метка",
  field_value_label: "Значение поля",
  add_new_field: "Добавить новое поле",
  tehran_address:
    "Тегеран, улица Шариати, после моста Сейед Хандан, переулок Хандан, № 6",
  welcome_message_hint:
    "Если включено, при присоединении клиента к вашему клубу будет отправлено приветственное сообщение.",
  change_pattern_campaign: "Изменить шаблон/кампанию",
  selected_message: "Выбранное сообщение:",
  required_inputs: "Обязательные поля:",
  selected_campaign_or_pattern: "Выбранная кампания/шаблон:",
  campaign: "Кампания",
  pattern: "Шаблон",
  id: "ID",
  auto_csv_download_label: "Автосохранение",
  auto_csv_download_hint:
    "После открытия карточки ваша информация автоматически скачается на мобильный клиента.",
  show_cclub_onload_label: "Предложение членства",
  show_cclub_onload_hint: "Откроется окно для присоединения к клубу клиентов.",
  forced_submission_hint:
    "С отображением формы членства клиент должен зарегистрировать свой номер.",
  forced_submission_forced: "Обязательное членство",
  forced_submission_optional: "Необязательное членство",
  has_manifest_icons_label: "Настройка веб-приложения",
  has_assistant_label: "Метка ассистента",
  select_assistant: "Выбрать ассистента",
  assistant_ai: "Ассистент ИИ",
  has_manifest_icons_hint:
    "Логотип и изображение появятся при установке веб-приложения на мобильный или компьютер.",
  logo_144px: "Логотип 144 px",
  logo_48px: "Логотип 48 px",
  photo_wide: "Широкое фото",
  photo: "Фото",
  iranian_social_networks: "Иранские социальные сети",
  foreign_social_networks: "Зарубежные социальные сети",
  advertising_sites: "Рекламные сайты",
  other_links: "Другие ссылки",
  custom_text: "Пользовательский текст",
  custom_text_placeholder: "Введите ваш пользовательский текст.",
  aparat: "Апарат",
  aparat_hint: "Введите название вашего канала на Апарат",
  eitaa: "Эйтаа",
  eitaa_hint: "Введите ваше имя пользователя",
  soroush: "Суруш",
  soroush_hint: "Введите ваше имя пользователя",
  bale: "Бале",
  bale_hint: "Введите ваше имя пользователя",
  rubika: "Рубика",
  rubika_hint: "Введите ссылку на канал/группу",
  gap: "Гап",
  gap_hint: "Введите ваше имя пользователя",
  linkedin: "Личный профиль LinkedIn",
  linkedin_hint: "Введите ваше имя пользователя",
  linkedin_company: "Страница компании в LinkedIn",
  linkedin_company_hint: "Введите название страницы вашей компании",
  pinterest: "Pinterest",
  pinterest_hint: "Введите ваше имя пользователя",
  dribbble: "Dribbble",
  dribbble_hint: "Введите ваше имя пользователя",
  facebook: "Facebook",
  facebook_hint: "Введите ваше имя пользователя",
  github: "GitHub",
  github_hint: "Введите ваше имя пользователя",
  threads: "Threads",
  threads_hint: "Введите ваше имя пользователя",
  tiktok: "TikTok",
  tiktok_hint: "Введите ваше имя пользователя",
  twitter: "Twitter",
  twitter_hint: "Введите ваше имя пользователя",
  skype: "Skype",
  skype_hint: "Введите ваше имя пользователя",
  youtube: "YouTube",
  youtube_hint: "Введите ваше имя пользователя без @",
  wechat: "WeChat",
  wechat_hint: "Введите ваше имя пользователя",
  viber: "Viber",
  viber_hint: "Введите ваше имя пользователя",
  divar: "Дивар",
  divar_hint: "Введите ссылку на объявление/доску/магазин",
  sheypoor: "Шейпур",
  sheypoor_hint: "Введите ссылку на объявление/доску/магазин",
  social_network: "Социальная сеть",
  photo_logo_tab: "Изображение/Логотип",
  gallery_image_tab: "Галерея изображений",
  template_image: "Изображение шаблона",
  background_image: "Фоновое изображение",
  upload_logo: "Загрузить логотип",
  welcome_image_upload: "Загрузить изображение/логотип приветствия",
  welcome_photo: "Фото приветствия",
  loading_animation: "Анимация загрузки",
  preview_welcome_page: "Предпросмотр страницы приветствия",
  default_template_image: "Фоновое изображение шаблона по умолчанию",
  default_background_image: "Фоновое изображение по умолчанию",
  default_logo: "Логотип по умолчанию",
  default_welcome: "Приветствие по умолчанию",
  default_gallery: "Галерея по умолчанию",
  animation_scale: "Масштабировать от центра",
  animation_slide_x: "Скользить слева",
  animation_slide_y: "Скользить сверху",
  animation_fade: "Затухание",
  image_size_error: "Максимальный размер фонового изображения: 2 МБ.",
  logo_size_error: "Максимальный размер логотипа: 2 МБ.",
  categories: {
    bankcard: 'Банковская карта',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "Текст",
    multi_card: "Мульти-карта",
    product_introduction_pro: "Презентация продукта Pro",
    "gift": "Подарок",
    link_pro:"Link Pro",
    generated_images: "Сгенерированные изображения",
    electronic_business_card: "Электронная визитная карточка",
    social_media: "Социальные сети",
    photo_gallery: "Фотогалерея",
    video_gallery: "Видеогалерея",
    link: "Ссылка",
    audio_gallery: "Аудиогалерея",
    audio_gallery_pro: "Аудиогалерея (Pro)",
    feedback: "Обратная связь",
    consultation_form: "Форма консультации",
    application: "Приложение",
    pdf_gallery: "PDF-галерея",
    schedule_table: "Таблица расписания",
    personal_company_website: "Личный/корпоративный сайт",
    online_store: "Онлайн-магазин",
    online_menu: "Онлайн-меню",
    appointment_booking: "Запись на приём",
    commercial_admin_website: "Коммерческий/админ сайт",
    online_insurance_sales: "Онлайн-продажа страховки",
    discount_code: "Код скидки",
    product_introduction: "Представление товара",
    product_label: "Метка товара",
    gold_label: "Метка золота",
    franchise: "Франшиза (бизнес-страница)",
    marketplace: "Маркетплейс (бизнес-страница)",
    recruitment_form: "Форма набора",
    organizational_form: "Организационная форма",
    employee_card: "Карточка сотрудника",
    book_magazine: "Книга/журнал",
    catalog_brochure: "Каталог/брошюра",
    catalog: "Каталог",
    faq: "FAQ",
    feedback_survey: "Обратная связь/опрос",
    consultation_request: "Запрос консультации",
    customer_club: "Клуб клиентов",
    invitation_card: "Пригласительная карточка",
    countdown: "Обратный отсчёт",
    tombstone: "Надгробие",
  },
  support_day60: "Гарантия возврата денег в течение 60 дней",
  "enter_visit_card_pro_info": "Введите название визитной карточки Pro",

  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "Редактировать текст QR",
        SERVER_DOWN: "Обновление системы",
    CREATE_MEMORIES_MODEL: "Создать шаблон рамки воспоминаний",
    CREATE_CARD_VISIT_PRO_MODEL: "Создать шаблон визитки Pro",
    CREATE_PRODUCT_PRO_MODEL: "Создать шаблон презентации товара Pro",
    CREATE_PRODUCT_LABEL_MODEL: "Создать шаблон этикетки товара",
    CREATE_PHOTO_GALLERY_MODEL: "Создать шаблон фотогалереи",
    CREATE_PDF_GALLERY_MODEL: "Создать шаблон галереи PDF",
    CREATE_SOCIAL_MEDIA_MODEL: "Создать шаблон соцсетей",
    EDIT_CARD_VISIT_PRO_MODEL: "Редактировать шаблон визитки Pro",
    EDIT_PRODUCT_PRO_MODEL: "Редактировать шаблон презентации товара Pro",
    EDIT_PRODUCT_LABEL_MODEL: "Редактировать шаблон этикетки товара",
    EDIT_PHOTO_GALLERY_MODEL: "Редактировать шаблон фотогалереи",
    EDIT_PDF_GALLERY_MODEL: "Редактировать шаблон галереи PDF",
    EDIT_SOCIAL_MEDIA_MODEL: "Редактировать шаблон соцсетей",
    BOOK: "Книга",
    NFC_LIST: "Список NFC",
    API_KEY_MANAGER: "Создать ключ API",
    PRE_PURCHASE: "Предзаказ",
    PRE_PURCHASE_MODEL: "Готовый шаблон",
      "QR_NAME_EDIT_GIFT": "Редактировать QR-код подарка",
      "QR_GIFT": "QR-код подарка",
      "QR_NAME_EDIT_PRO": "Изменить QR-код ссылки Pro",
      "QR_LINK_PRO": "QR Link Pro",
      DIGI: "Мониторинг цен Digikala",
      QR_PDF: "Галерея PDF",
      QR_NAME_EDIT_PDF: "Редактировать галерею PDF",
      QR_MULTICART: "QR Мультикарта",
      QR_MULTICART_EDIT: "Редактировать QR Мультикарту",
      QR_NAME_PRODUCTPRO: "Редактировать представление Product Pro",
      QR_PRODUCTPRO: "Представление Product Pro",
      QR_CATALOG: "Каталог / Брошюра",
      QR_NAME_EDIT_CATALOG: "Редактировать каталог",
      QR_LUCK_WHEEL_Edit: "Редактировать колесо удачи",
      QR_LUCK_WHEEL: "Создать QR-код для колеса удачи",
      DASHBOARD: "Панель управления",
      ADMIN_QR_DOMAINS: "Мониторинг доменов",
      ADMIN_TOGETHER_TOKEN: "Мониторинг токенов",
      ADMIN_QR_SMS: "Отправка SMS",
      MENU_PROFILE_INFO: "Информация о пользователе",
      MENU_PROFILE_SETTING: "Настройки профиля",
      MENU_PROFILE_ORDERS: "Заказы",
      MENU_PROFILE_ADDRESSES: "Адреса",
      QR_MONITORING: "Мониторинг QR",
      QR_LIST: "Мой список QR",
      QR_NAME_LIST: "Управление участием",
      QR_GENERATE_MULTIPLE: "Массовое создание QR-кодов",
      QR_CARD_VISIT: "Создать визитную карточку",
      HELP_INFO: "Тестировать кнопку",
      QR_MENU: "Меню магазина",
      QR_APPOINTMENT: "Запись на прием",
      QR_INSURANCE: "Создать онлайн-страховку",
      QR_BPAGE: "Создать бизнес-страницу",
      QR_CPAGE: "Создать сайт торгового/административного комплекса",
      QR_BSHOP: "Онлайн-магазин",
      QR_NAME_EDIT_BSHOP: "Редактировать онлайн-магазин",
      QR_LINK_EDIT: "Редактировать ссылку",
      QR_NAME_DESIGN: "Редактировать дизайн",
      QR_NAME_SETTING: "Редактировать настройки",
      QR_NAME_EDIT: "Редактировать визитную карточку",
      QR_NAME_EDIT_BPAGE: "Редактировать бизнес-страницу",
      QR_EDIT_CPAGE: "Редактировать сайт торгового/административного комплекса",
      QR_NAME_INSURANCE: "Редактировать онлайн-страховку",
      QR_NAME_EDIT_MENU: "Редактировать меню",
      QR_NAME_EDIT_APPLICATION: "Предоставить приложение",
      QR_NAME_EDIT_APPOINTMENT: "Редактировать запись на прием",
      QR_NAME_EDIT_PHOTO: "Редактировать галерею фото",
      QR_NAME_EDIT_VIDEO: "Редактировать галерею видео",
      QR_NAME_EDIT_VOICE: "Редактировать галерею аудио",
      QR_NAME_EDIT_FEEDBACK: "Редактировать галерею отзывов",
      QR_NAME_CONSULTATION_QR_EDIT: "Редактировать форму заявки",
      QR_NAME_EDIT_VOICE_PRO: "Редактировать галерею аудио (Pro)",
      QR_NAME_EDIT_SOCIAL: "Редактировать социальные сети",
      QR_NAME_STATISTICS: "Статистика QR-кода",
      QR_CATE: "Выбрать категорию",
      QR_SHARE: "Поделиться",
      QR_BUSINESS_SHOP: "Бизнес/Магазин",
      QR_CO_ORGAN: "Компания/Организация",
      QR_CONTACT: "Контакт с клиентом",
      QR_NOTICES: "Уведомления",
      QR_OTHERS: "Разное",
      QR_STATICS: "Статический QR",
      QR_DYNAMICS: "Динамический QR",
      QR_D_BUSINESS: "Динамический бизнес QR",
      QR_D_ORGANS: "Динамический организационный QR",
      QR_D_GOVERNMENT: "Динамический правительственный QR",
      QR_VIDEO: "Галерея видео",
      QR_APPLICATION: "Предоставить приложение",
      QR_VOICE: "Галерея аудио",
      QR_VOICE_PRO: "Галерея аудио (Pro)",
      QR_CONSULTATION_QR: "Форма заявки",
      QR_FEEDBACK: "Галерея отзывов",
      QR_PHOTO: "Галерея фото",
      QR_LOCATION: "Создать QR для местоположения",
      QR_SOCIAL_MEDIA: "Создать QR для социальных сетей",
      QR_LINK: "Создать ссылку",
      QR_TEXT: "Создать текст",
      QR_MAIL: "Создать email",
      QR_CALL: "Звонок",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Веб-сайт",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "Бизнес-страница",
      QR_DISCOUNT: "Страница скидки",
      QR_PRODUCT_SHOP: "Представление продукта",
      QR_PRODUCT_LABEL: "Этикетка продукта",
      QR_GOLD_LABEL: "Золотая этикетка",
      QR_PRODUCT_TEMPLATE: "Продукты",
      ADMIN_CATEGORY: "Категории",
      QR_NFC_ORDERS: "NFC-карты ожидают подтверждения",
      QR_NAME_PRODUCT: "Редактировать представление продукта",
      QR_NAME_LABELPRODUCT: "Редактировать этикетку продукта",
      QR_NAME_GOLDPRODUCT: "Редактировать золотую этикетку",
      QR_COINS: "Криптовалюты",
      QR_SHOP: "Управление магазином",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Центр загрузки",
      PRICING: "Тарифы QR",
      QR_CREATE_MODELS: "Создать модель визитной карточки",
      QR_CREATE_BUSINESS_MODELS: "Создать модель бизнес-страницы",
      QR_CREATE_PRODUCT_MODEL: "Создать модель карточки продукта",
      QR_CREATE_MENU_MODELS: "Создать модель меню магазина",
      QR_CREATE_SHOP_MODEL: "Создать модель онлайн-магазина",
      MODELS_LIST: "Типы моделей QR",
      MODELS_LIST_EDIT: "Редактировать модель",
      MODELS_LIST_MENU_EDIT: "Редактировать модель меню",
      MODELS_LIST_BMODEL_EDIT: "Редактировать модель онлайн-магазина",
      NFC: "NFC-карты",
      SUBMIT_FORM: "Зарегистрировать блогера",
      REQUEST_LIST: "Список блогеров",
      PURE_DATA: "Список несозданных визитных карточек",
      AUTO_CREATE: "Автоматическое создание QR",
      QR_CREATE: "Создать QR",
      HISTORY_REMINDER: "Мониторинг напоминаний",
      BOOK: "Мониторинг напоминаний"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "Способы оплаты",
      ORDER_NOTIFICATIONS: "Уведомления о заказах",
      DISCOUNT_CODE: "Код скидки",
      CART: "Корзина покупок",
      TABLE_MANAGEMENT: "Управление столами",
    },
    ERRORS: {
      INVALID_INPUT: "Пожалуйста, введите значения правильно!",
      CART_SETTINGS_FAILED: "Настройки корзины покупок не удались!",
    },
  },
  popup: {
    prepared_stores_title: "Готовые примеры онлайн-магазинов",
  },
  buttons: {
    reset_defaults: "Сбросить данные по умолчанию",
    download_qr: "Скачать QR",
    cleardefaults: "Очистить информацию по умолчанию",
    select_prepared_store: "Выбрать готовый онлайн-магазин",
  },
  stepper: {
    create_qr: "Создать QR",
    products_info: "Продукты и информация",
    content_settings: "Настройки содержимого",
    sales_settings: "Настройки продаж",
  },
  fields: {
    online_store_name: "Название онлайн-магазина",
    qr_address: "Адрес QR",
    qr_address_hint: "Введите ваш адрес QR",
    online_sale: "Онлайн-продажа",
  },
  login_settings: "Настройки входа",
  shop_logo_and_images: "Логотип и изображения магазина",
  login_page_info: "Информация страницы входа",
  upload_banner: "Загрузить баннер",
  create_product: "Создать продукт",
  special_sale: "Специальная продажа",
  ended: "Завершено",
  blog: "Блог",
  services: "Услуги",
  pdf_gallery: "Галерея PDF",
  create_section: "Создать раздел",
  achievements: "Достижения",
  team_members: "Члены команды",
  working_hours: "Часы работы",
  saturday: "Суббота",
  sunday: "Воскресенье",
  monday: "Понедельник",
  tuesday: "Вторник",
  wednesday: "Среда",
  thursday: "Четверг",
  friday: "Пятница",
  we_will_be_different: "Мы будем другими...",
  striving_for_excellence: "Мы всегда стремимся быть лучшими >>> для вас",
  online_store_ready_15_minutes: "Ваш онлайн-магазин готов за 15 минут!",
  sales_management: "Управление продажами",
  dear_customer_online_stores:
    "Уважаемый клиент, вы также можете покупать в наших других онлайн-магазинах:",
  divar_site: "Сайт Divar",
  digikala_site: "Сайт Digikala",
  basalam_site: "Сайт Basalam",
  torob_site: "Сайт Torob",
  emalls_site: "Сайт Emalls",
  copyright_qrland: "Все права защищены QR Land.",
  tehran_address:
    "Тегеран, улица Шариати, после моста Сейед Хандан, переулок Хандан, № 6",
  our_achievements: "Достижения нашей группы",
  customer_satisfaction: "Удовлетворенность клиентов",
  lowest_returns: "Наименьшее количество возвратов",
  loyal_customer: "Лояльный клиент",
  shipped_orders: "Отправленные заказы",
  visit_our_videos: "Посмотрите видео нашей группы.",
  bringing_the_best: "Мы принесли вам лучшее...",
  feedback_important: "Ваш отзыв важен для нас",
  guide_us_with_feedback:
    "Пожалуйста, помогите нам предоставлять лучшие услуги, отвечая на вопросы ниже.",
  satisfied_with_quality: "Довольны ли вы качеством товаров?",
  evaluate_packaging_quality: "Как вы оцениваете качество упаковки?",
  satisfied_with_variety: "Довольны ли вы разнообразием товаров?",
  benefited_from_discounts: "Воспользовались ли вы скидками этого магазина?",
  post_1: "Пост 1",
  fast_order_delivery: "Быстрая доставка заказа",
  post_2: "Пост 2",
  post_3: "Пост 3",
  product_authenticity_guarantee: "Гарантия подлинности продукта",
  comfortable_purchase: "Комфортная покупка",
  how_to_place_order: "Как я могу разместить заказ?",
  add_to_cart: "Просто добавьте желаемые товары в корзину покупок.",
  how_to_register: "Как зарегистрироваться на сайте?",
  click_login_and_enter_code:
    "Просто нажмите кнопку «Вход» и, введя номер мобильного телефона, введите код из SMS.",
  delivery_time:
    "Сколько времени займет доставка моего заказа после регистрации?",
  fastest_delivery: "Ваш заказ будет отправлен как можно быстрее.",
  shipping_cost: "Сколько стоит доставка?",
  shipping_cost_order: "Стоимость доставки заказа",
  variable_shipping_cost:
    "Стоимость доставки варьируется в зависимости от вашего адреса.",
  change_or_cancel_order:
    "Могу ли я изменить или отменить заказ после размещения?",
  no_change_or_cancel: "Нет. Изменение или отмена невозможны.",
  mrs_Safdarian: "Г-жа Сафдарян",
  invalid_address: "Введенный адрес недействителен!",
  shop_page_created_success: "Ваша страница магазина успешно создана.",
  qr_creation_failed: "Создание QR не удалось!",
  server_error: "Ошибка сервера!",
  qr_card_updated_success: "Ваша визитная карточка успешно отредактирована.",
  qr_save_edit_failed: "Ошибка при сохранении/редактировании QR",
  your_feedback: "Ваш отзыв",
  digital_marketing_strategy:
    "Поставьте свою компанию на правильный путь с нашим стратегом цифрового маркетинга",
  wait_for_default_products:
    "Пожалуйста, подождите, пока продукты по умолчанию полностью загрузятся на вашем сайте.",
  template_categories_saved: "Категории шаблона успешно сохранены.",
  template_products_saved: "Продукты шаблона успешно сохранены.",
  template_products_save_failed: "Ошибка при сохранении продуктов шаблона!",
  template_categories_save_failed: "Ошибка при сохранении категорий шаблона!",
  login_page_text: "Текст страницы входа",
  persian_error: "Текст должен быть на персидском",
  number_error: "Введенные данные не должны быть нечисловыми или пустыми",
  english_error: "Текст не должен быть неанглийским или пустым",
  mixPerEng_error:
    "Текст не должен быть неанглийским или не персидским или пустым",
  email_error: "Введенный формат email недействителен",
  mobile_error: "Введенный формат номера недействителен",
  meliCode_error: "Введенный формат национального кода недействителен",
  site_error: "Введенный формат сайта недействителен",
  min_length_error: "Введенное значение не может быть меньше {{min}}",
  max_length_error: "Введенное значение не может быть больше {{max}}",
  form_submitted_message: "Ваша форма успешно отправлена",
  required_fields_error: "Обязательные значения не введены",
  headphone_title: "Наушники",
  buy_button: "Купить",
  day: "день",
  hour: "час",
  minute: "минута",
  second: "секунда",
  required_field_error: "{{fieldName}} обязательно",
  submit_request_button: "Отправить запрос",
  request_submitted_success: "Ваш запрос успешно зарегистрирован",
  feedback_submitted_success: "Ваш отзыв успешно зарегистрирован",
  description_required_label: "Описание (обязательно)",
  description_optional_label: "Описание (необязательно)",
  description_hint:
    "Пожалуйста, введите желаемое описание в это поле (минимум 3 символа)",
  footer: {
    position: "Сторона",
    contactUs: "Свяжитесь с нами",
    aboutUs: "О нас",
    firstShift: "Первая смена",
    secondShift: "Вторая смена",
    startTime: "Время начала",
    endTime: "Время окончания",
    features: "Функции",
    partners: "Партнеры",
    affiliates: "Аффилированные программы",
    panels: "Панели",
    supportTicket: "Тикет поддержки",
    inPersonServices: "Очные услуги",
    liveChat: "Живой чат",
    faq: "Часто задаваемые вопросы",
    add_secondshift: "Добавить вторую смену",
    firstDate: "Дата начала",
    endDate: "Дата окончания",
  },
  qr_management: "Управление QR",
  restore_default_questions: "Восстановить вопросы по умолчанию",
  delete_all: "Удалить все",
  edit_question: "Редактировать вопрос",
  move_up: "Переместить вверх",
  move_down: "Переместить вниз",
  delete: "Удалить",
  selected_question: "Выбранный вопрос",
  question: "Вопрос",
  answer_type: "Тип ответа",
  excellent: "Отлично",
  good: "Хорошо",
  very_poor: "Очень плохо",
  response_optionality: "Необязательный / Обязательный ответ",
  required: "Обязательно",
  optional: "Необязательно",
  add_new_question: "Добавить новый вопрос",
  satisfied_with_quality: "Довольны ли вы качеством товаров?",
  evaluate_packaging_quality: "Как вы оцениваете качество упаковки?",
  satisfied_with_variety: "Довольны ли вы разнообразием товаров?",
  benefited_from_discounts: "Воспользовались ли вы скидками этого магазина?",
  suggestions_for_improvement:
    "Какое предложение у вас есть для улучшения опыта покупок в этом магазине?",
  confirm_delete_question: "Удалить выбранный вопрос?",
  question_deleted_success: "Вопрос успешно удален.",
  question_delete_failed: "Ошибка при удалении вопроса!",
  confirm_delete_all_questions: "Вы уверены, что хотите удалить все вопросы?",
  questions_deleted_success: "Вопросы успешно удалены.",
  questions_delete_failed: "Ошибка при удалении вопросов!",
  invalid_input: "Пожалуйста, введите значения правильно!",
  operation_failed: "Операция не удалась!",
  question_number: "Вопрос {number}?",
  card_subtitle:
    "Просто введите историю желаемого изображения, и ИИ создаст его для вас.",
  upgrade_label: "Прикрепить",
  free: " - Бесплатно",
  language_select: "Выбрать язык для написания текста запроса",
  image_size: "Размер изображения",
  prompt_label: "Текст запроса",
  prompt_placeholder: "Опишите желаемое изображение...",
  generate_image: "Создать изображение",
  regenerate_image: "Создать новое изображение",
  save_image: "Сохранить изображение",
  save_image_subtitle: "Сохранится только изображение, отображаемое выше.",
  size_items: {
    "16:9": "16:9 (горизонтальное)",
    "9:16": "9:16 (вертикальное)",
    "1:1": "1:1 (квадратное)",
  },
  lang_items: {
    fa: "Fa | Персидский",
    en: "En | Английский",
    ar: "Ar | Арабский",
  },
  rules: {
    empty: "Необходимо ввести минимум 3 символа!",
    spell_checker: "Введенный текст должен быть на языке {language}!",
  },
  ERRORS: {
    VpnDetectedTitle: "Отключите VPN",
    VpnDetectedSubtitle:
      "Это помогает системе работать лучше и предоставляет вам лучший опыт.",
  },
  errors: {
    VpnDetectedTitle: "Отключите VPN",
    VpnDetectedSubtitle:
      "Это помогает системе работать лучше и предоставляет вам лучший опыт.",
    invalid_size: "Пожалуйста, введите ширину и высоту правильно!",
    image_generation_error: "Ошибка при создании изображения",
    image_upload_error: "Ошибка при загрузке изображения!",
    service_unavailable:
      "Этот сервис недоступен — при загрузке данных с сервера произошла ошибка",
    qr_address_taken: "Этот QR‑адрес уже занят",
  },
  add_working_time: "Добавить рабочее время",
  selected_day: "Выбранный день",
  range_name: "Название временного диапазона",
  add: "Добавить",
  first_shift: "Первая смена",
  second_shift: "Вторая смена",
  start_time: "Время начала",
  end_time: "Время окончания",
  date_range: "Диапазон дат",
  all_week_days: "Все дни недели",
  saturday_to_wednesday: "С субботы по среду",
  saturday_to_thursday: "С субботы по четверг",
  work_week: "Все дни недели (кроме праздников)",
  feedbacks: "Отзывы",
  failed_retrieve_feedback: "Не удалось получить отзывы!",
  province: "Провинция",
  search_city_placeholder: "Поиск желаемого названия города.",
  search_city_label: "Поиск города",
  welcome: "Добро пожаловать в наше приложение",
  description: "Это многоязычное приложение.",
  soon: "Скоро",
  beta_version: "Бета-версия",
  defaults_cleared_success: "Данные по умолчанию успешно очищены",
  defaults_reset_success: "Данные по умолчанию успешно сброшены",
  select_navigator_after_location_click:
    "После нажатия на местоположение выберите желаемый навигатор",
  no_address_selected: "Адрес не выбран",
  no_location_selected: "Местоположение не выбрано",
  region: "Регион",
  api_unauthorized: "Ошибка аутентификации: Недействительный ключ API",
  location_not_found: "Местоположение не найдено",
  addCategory: "Добавить новую категорию",
  editCategory: "Редактировать категорию",
  deleteCategory: "Удалить выбранную категорию?",
  addProduct: "Добавить новый продукт",
  saveProducts: "Выбрать продукты по умолчанию",
  addSubCategory: "Добавить подкатегорию",
  product: "Продукт",
  categoryName: "Название категории",
  subCategoryName: "Название подкатегории",
  confirmDeleteProduct: "Удалить продукт из категории?",
  successMessages: {
    categorySaved: "Категории успешно сохранены.",
    productSaved: "Продукты успешно сохранены.",
    productDeleted: "Продукт успешно удален.",
  },
  errorMessages: {
    saveCategoryFailed: "Ошибка сохранения категорий!",
    saveProductFailed: "Ошибка сохранения продуктов!",
    deleteCategoryFailed: "Ошибка удаления категории!",
  },
  add_edit_categories: "Добавить/редактировать категорию",
  copy_category: "Копировать категорию",
  product: "Продукт {point}",
  copy_product: "Копировать продукт",
  add_edit_products: "Добавить/редактировать продукты",
  edit_category: "Редактировать категорию",
  category_name: "Название категории",
  edit_subcategory: "Редактировать подкатегорию",
  subcategory_name: "Название подкатегории",
  add_new_category: "Добавить новую категорию",
  store_management: "Управление магазином",
  manage_products: "Управление продуктами",
  products_export: "Скачать продукты",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "Загрузить файл Excel",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "Перетащите ваш файл Excel сюда или",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "выберите его",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "для загрузки",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE":
    "Пожалуйста, загружайте только файлы Excel (.xlsx)",
  "GENERAL.SUBMIT": "Отправить",
  "GENERAL.CANCEL": "Отмена",
  "GENERAL.SUCCESSFULLY_ADDED": "Продукты успешно загружены",
  SUCCESSFULLY_DOWNLOADED: "Продукты успешно скачаны",
  "GENERAL.ERROR": "Произошла ошибка",
  EditSubCategoty: "Редактировать подкатегорию",
  create: "Создать",
  save_changes: "Сохранить изменения",
  buy_button_settings: "Настройки кнопки покупки",
  image: "Изображение",
  color: "Цвет",
  title: "Название",
  price: "Цена",
  discount: "Скидка",
  percent: "Процент",
  amount: "Сумма",
  brand: "Бренд",
  inventory: "Запас",
  inventory_hint: "Оставьте пустым = неограниченное количество заказа",
  order_limit: "Макс. количество на заказ",
  order_limit_hint: "Оставьте пустым = без ограничений",
  packing_price: "Стоимость упаковки",
  packing_price_hint: "Применяется для внешних заказов (курьер/самовывоз).",
  description: "Описание",
  options: "Опции",
  product_features: "Характеристики продукта",
  field_required: "Обязательное поле.",
  min_length: "Требуется минимум 3 символа.",
  product: "Продукт",
  default_brand: "Apple",
  product_added_success: "Продукт успешно добавлен",
  product_added_error: "Ошибка добавления продукта",
  whole_categories: "(Все категории)",
  add_select_category: "Добавить/выбрать категорию",
  select_default_category: "Выбрать категорию по умолчанию",
  deleted_product: "Удалить продукт",
  confirm_delete_prooduct: "Удалить продукт из категории?",
  please_wait_store_product: "Продукты сохраняются, пожалуйста, подождите...",
  saved_product_success: "Продукты успешно сохранены.",
  error_in_store: "Ошибка сохранения",
  delete_category: "Удалить категорию",
  confirm_delete_category: "Категория успешно удалена.",
  error_delete_category: "Ошибка удаления категории!",
  productOptionEditor: {
    tabs: {
      color: "Цвет",
      size: "Размер",
      count: "Количество",
      weight: "Вес",
      type: "Тип/Пол",
    },
    fields: {
      count: "Количество",
      max_order: "Макс. количество заказа",
      price: "Цена",
      discount: "Скидка",
      color: "Цвет",
      color_name: "Название цвета",
      inventory: "Запас",
      size: "Размер",
      type: "Тип/Пол",
      weight: "Вес",
    },
    actions: {
      delete: "Удалить",
      add_location: "Добавить опцию",
    },
  },
  extraSubProducts: {
    feature: "Характеристика",
    name_label: "Название",
    name_placeholder: "Пример: Дополнительный соус / Дополнительный хлеб",
    price_label: "Цена",
    price_hint: "Оставьте пустым = бесплатное дополнение.",
    price_placeholder: "Пример: Вода, Тип (например, куриная грудка/бедро)",
    add_subproduct: "Добавить дополнительный продукт",
  },
  error_selected_category: "Ошибка выбора категории!",
  suggestinput: {
    title: "Выбрать эмодзи",
    aboutUs: "О нас",
    error: "Ошибка",
    errorMessage: "Пожалуйста, пополните кредит и попробуйте снова.",
    generateText: "Предложение текста ИИ",
    emoji: "Эмодзи",
    errorMessage_400:
      "Ошибка создания текста 'О нас'. Пожалуйста, попробуйте снова.",
    errorMessage_403:
      "Ошибка создания текста 'О нас'. Купите пакет и попробуйте снова.",
  },
  togetherai: {
    buy_package: "Купить пакет",
    tax_notice: "К цене пакета будет добавлен НДС 10%!",
    package: "Пакет",
    rial: "Риал",
    buy_button: "Купить!",
    discount_label: "Код скидки",
    submit_discount: "Активировать",
    success_message: "Ваш QR успешно обновлен.",
    error_insufficient_funds: "Проверьте ваш кредит и попробуйте позже.",
    error_upgrade: "Ошибка обновления QR!",
    error_title: "Ошибка",
    success_title: "Успех",
  },
  category_not_found: "Категория не найдена!",
  create_upload_category: "Создать и загрузить категорию",
  add_subcategory: "Добавить подкатегорию",
  error_upload_m_video:
    "Ошибка загрузки видео (возможно, ограниченный доступ).",
  info_show_video: "Нажмите 'Больше' для показа дополнительно.",
  error_not_valid_guide_id: "Недействительный ID гида!",
  error_give_guide_info: "Ошибка получения информации о гиде!",
  info_success_saved: "Успешно сохранено",
  error_add_new_guide: "Ошибка добавления нового гида",
  popup: {
    details: "Детали",
    guide_images: "Изображения гида",
    guide_videos: "Видео гида",
    faq: "FAQ",
    no_title: "Без названия",
    no_content: "Нет содержимого для отображения",
    no_questions: "Нет вопросов для отображения",
    video_error: "Ошибка загрузки видео (возможно, ограниченный доступ)",
    no_answer: "Нет ответа",
    question_no_title: "Вопрос без названия",
    default_title: "Гид",
  },
  productPicker: {
    select_default_product: "Выбрать продукт по умолчанию",
    search: "Поиск",
    select_all_products: "Выбрать все продукты",
    back: "Назад",
    no_products_in_category: "Нет продуктов в этой категории!",
    products_error: "Ошибка загрузки продуктов!",
    retry: "Повторить",
    items_per_page: "Элементов на странице",
    root_breadcrumb: "/",
  },
  end_date: "Дата окончания",
  filters: {
    userType: {
      legal: "Юридическое лицо",
      individual: "Физическое лицо",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "Биллборд",
      tablighNegar: "TablighNegar",
      unknown: "Неизвестно",
    },
    qrType: {
        gift: "Рамка воспоминаний",
        instagram: "Instagram",
        visitCard: "Визитная карточка",
        Business: "Личная / Корпоративная",
        Commericial: "Сайт торгового / офисного комплекса",
        qrlink: "QR-ссылка",
        labelproduct: "Этикетка товара",
        goldLabel: "Золотая этикетка",
        bShop: "Магазин",
        SocialMedia: "Социальные сети",
        VideoGallery: "Видеогалерея",
        PhotoGallery: "Фотогалерея",
        voiceGallery: "Аудиогалерея",
        consultationQr: "Форма заявки",
        application: "Приложение",
        feedbackGallery: "Обратная связь",
        voiceGalleryPro: "Профессиональная аудиогалерея",
        singleProduct: "Презентация товара",
        menu: "Меню",
        appointment: "Запись на приём",
        insurance: "Страхование",
        text: "Текст",
        luck_wheel: "Колесо удачи",
        pdfgallery: "PDF-галерея",
        productpro: "Pro-презентация товара",
        multicard: "Мультикарта",
        catalog: "Каталог",
        visitCard_pro: "Pro-визитка",
        clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "День",
      expired: "Истек",
    },
    numericPersianNumber: {
      thousand: "Тысяча",
      million: "Миллион",
    },
    dateString: {
      at: "в",
    },
    messages: {
      pleaseLogin: "Пожалуйста, войдите",
      invalidPhone: "Неверный номер телефона",
      copied: "Скопировано",
    },
  },
  nextButton: "Далее",
  previousButton: "Назад",
  rowsPerPageText: "Строк на странице",
  noDataText: "Нет данных для отображения",
  placeholderSearch: "Поиск..",
  set_qr: "QR зарегистрирован",
  numbers: "Числа",
  enter_param_product: "Введите данные продукта правильно!",
  instagram_hint: "Введите ваш Instagram",
  whatsapp_hint: "Введите ваш WhatsApp",
  telegram: "Telegram",
  telegram_hint: "Введите ваш Telegram",
  userpicker: {
    select_user: "Выбрать пользователя",
    choice_users: "Выбрать пользователей",
    id: "ID",
    phone_number: "Мобильный номер",
    date_created: "Дата создания",
    info_edit: "Редактировать информацию",
    name_family: "Имя и фамилия",
    position: "Должность и звание",
    phone: "Телефон",
    discription: "Описание",
  },
  search_product: "Поиск продукта",
  search_name_product: "Поиск названия продукта",
  currency: "Риал",
  headers: {
    index: "Порядок",
    gallery: "Изображение",
    id: "ID",
    name: "Название",
    brand: "Бренд",
    price: "Сумма",
    discount_amount: "Скидка",
  },
  search_categories: "Поиск в категориях",
  delete_all: "Удалить все",
  select_category: "Выбрать категорию",
  currency1: "Иранский риал",
  features: "Характеристики",
  product_sp: {
    edit: "Редактировать",
    back: "Назад",
    save: "Сохранить",
    add_product_to_special_category:
      "Заполните поля для добавления продукта в специальную категорию",
    inventory: "Запас",
    discount: "Скидка",
    max_per_customer: "Макс. на клиента",
    max_per_order: "Макс. на заказ",
    expires_at: "Дата истечения",
    field_cannot_be_empty: "Поле не может быть пустым.",
    please_enter_correctly: "Пожалуйста, заполните правильно!",
    currency: "Иранский риал",
  },
  selectproduct: "Выбрать продукт",
  section: {
    edit_part: "Редактировать раздел",
    title: "Заголовок",
    position_text: "Положение текста",
    add_video: "Добавить видео",
    text: "Текст",
    address_video: "URL видео",
    position_left: "Слева",
    position_right: "Справа",
    tab_edit_button: "Кнопка редактирования",
    tab_content: "Содержимое раздела",
  },
  name_shopping: "Название магазина",
  hint_shopping: "Введите название вашего магазина.",
  title_discount: "Заголовок скидки",
  hint_discount: "Введите заголовок вашей скидки.",
  hint_mount_discount: "20% скидка на следующий заказ.",
  label_discount: "Введите сумму скидки",
  give_discount: "Получить код скидки",
  give_copon: "Получить купон",
  enter_copon: "Введите купон",
  hint_phone: "Введите ваш номер телефона.",
  label_phone: "Номер телефона",
  hint_condition_discount: "Опишите условия скидки..",
  label_discription_discount: "Описание скидки",
  add_info_discount: "Добавить дополнительную информацию:",
  enter_address_discount: "Введите ваш адрес.",
  address_discount: "Адрес",
  edit_feedback: "Редактировать отзыв",
  select_type_replay: "Выбрать тип ответа",
  field_discription: "Поле описания",
  messages_discription:
    "Включите, чтобы показать поле описания для пользователя",
  number_char: "Количество символов должно быть от 3 до 50!",
  search: "Поиск",
  no_videos_found: "Видео не найдены!",
  upload_video_prompt:
    "Используйте область загрузки видео для добавления файла",
  delete_success: "Успешно удалено.",
  tabs: {
    qr_view: "Просмотр QR",
    preview: "Предпросмотр",
    ready_video: "Готовое видео",
    video_gallery: "Видеогалерея",
    link: "Ссылка",
    video_upload: "Загрузка видео",
  },
  consultation: {
    name: "Имя",
    surname: "Фамилия",
    phone: "Мобильный номер",
    nationalId: "Национальный ID",
    nationalIdAuthenticate: "Проверить национальный ID",
    nationalIdCorrect: "Проверить корректность национального ID",
    mail: "Email",
    address: "Адрес",
    location: "Местоположение",
    custom: "Пользовательский",
    customLabel: "Заголовок",
    customOptions: "Опции",
    optional: "Необязательно",
    require: "Обязательно",
    description: "Описание",
  },
  add_section: "Добавить раздел",
  add_new_text_section:
    "Вы тепло приглашены в интеллектуальную цифровую землю QR-Land.",
  btn_title_section: "Бесплатная регистрация",
  shop: {
    step_products_and_info: "Продукты и информация",
    online_store_name: "Название онлайн-магазина",
    qr_address: "Адрес QR",
    qr_address_hint: "Введите ваш адрес QR",
    online_sale: "Онлайн-продажа",
    step_content_settings: "Настройки содержимого",
    step_sale_settings: "Настройки продаж",
    download_qr: "Скачать QR",
    login_settings: "Настройки входа",
    store_logo_images: "Логотип и изображения магазина",
    login_page_info: "Информация страницы входа",
    upload_banner: "Загрузить баннер",
    user_info: "Информация пользователя",
    create_product: "Создать продукт",
    special_sale: "Специальная продажа",
    add_social_media: "Добавить социальные сети",
    blog: "Блог",
    services: "Услуги",
    faq: "FAQ",
    photo_gallery: "Фотогалерея",
    video_gallery: "Видеогалерея",
    pdf_gallery: "PDF-галерея",
    feedback: "Отзывы",
    countdown: "Обратный отсчет",
    request_form: "Форма запроса",
    create_section: "Создать раздел",
    achievements: "Достижения",
    team_members: "Члены команды",
    working_hours: "Часы работы",
    error_saving_content: "Ошибка сохранения настроек содержимого!",
    success_edit_store: "Страница магазина успешно отредактирована.",
    post_1: "Пост 1",
    logo: "Логотип",
    background_image: "Фоновое изображение",
  },
  discount_obj: {
    quantity: "количество",
    create_edit_code: "Создать/редактировать код скидки",
    coding_type_label: "Тип создания",
    coding_type_single: "Одиночный",
    coding_type_group: "Групповой",
    status_label: "Статус",
    status_active: "Активен",
    status_deactivate: "Деактивирован",
    discount_code: "Код скидки",
    discount_type: "Тип скидки",
    discount_type_percent: "Процент",
    discount_type_fixed: "Фиксированная сумма",
    discount_value: "Значение скидки",
    discount_limit: "Лимит скидки",
    no_limit: "Без лимита",
    tab_create_discount: "Создать код скидки",
    tab_settings: "Настройки",
    success_create: "Код скидки успешно создан",
    success_edit: "Код скидки успешно отредактирован",
    error_value_empty: "Значение скидки не может быть пустым!",
    error_start_time: "Не выбрано время начала!",
    error_end_time: "Не выбрано время окончания!",
    error_same_time: "Время начала и окончания не могут совпадать",
  },
  personnel: {
    team_members: "Выбранные члены команды",
    add_team_member: "Добавить члена команды",
    default_position: "Должность и звание",
    default_phone: "Номер телефона",
    default_full_name: "Полное имя",
    default_description:
      "Lorem Ipsum — это просто фиктивный текст полиграфической промышленности, используемый дизайнерами на протяжении веков",
  },
  discount_settings: {
    function_type: {
      title: "Функция скидки",
      all_shopping_cart: "Общая сумма корзины",
      special_products: "Специальные продукты",
      special_categories: "Специальные категории",
    },
    basket_condition: {
      title: "Условия корзины",
      no_conditions: "Без условий",
      minimum_shopping: "Минимальная сумма корзины",
      minimum_product: "Минимальное количество продуктов в корзине",
      maximum_shopping: "Максимальная сумма корзины",
      maximum_product: "Максимальное количество продуктов в корзине",
    },
    user_settings: {
      title: "Настройки пользователя",
      all_user: "Все пользователи",
      group: "Группа пользователей",
      special: "Специальные пользователи",
    },
    limitation_use: {
      title: "Ограничение использования",
      no_limitations: "Без ограничений",
      discount_code: "Количество использований кода скидки",
      user: "Использований на пользователя",
    },
    start_time: {
      title: "Дата начала скидки",
      no_time_selected: "Не выбрано время начала",
    },
    end_time: {
      title: "Дата окончания скидки",
      no_time_selected: "Не выбрано время окончания",
    },
  },
  counterService: {
    typeLabel: "Тип отображения",
    number: "Число",
    percent: "Процент",
    iconLabel: "Иконка",
    counterLabel: "Значение",
    linkLabel: "Ссылка",
    nameLabel: "Заголовок",
    addButton: "Добавить успех",
    successful: {
      added: "Элемент успешно добавлен",
      removed: "Элемент успешно удален",
      movedUp: "Элемент успешно перемещен вверх",
      movedDown: "Элемент успешно перемещен вниз",
    },
  },
  qrUsersList: {
    customersList: "Список клиентов",
    orders: "Заказы",
    addresses: "Адреса",
    hasAssistantsMobile_hint: "Выбрать мобильный",
    invalidPhone: "Введённый номер мобильного телефона недействителен",
    validation: {
      nameRequired: "Введите имя",
      nameMinLength: "Имя должно содержать не менее 2 символов",
      familyRequired: "Введите фамилию",
      familyMinLength: "Фамилия должна содержать не менее 2 символов",
    },
    addUser: "Добавить пользователя",
    registerOnline: "Включить онлайн-регистрацию",
    usersColumns: {
      id: "ID",
      name: "Имя",
      family: "Фамилия",
      mobile: "Мобильный",
      subscriptionId: "ID подписки",
      ordersCount: "Количество заказов",
      lastLogin: "Последний вход",
      status: "Статус",
      activeUser: "Активный пользователь",
      none: "-",
      actions: "Действия",
      buttons: {
        info: "Данные клиента",
        sendSms: "Отправить SMS",
        history: "История",
        addresses: "Адреса",
        orders: "Заказы",
      },
    },
    orderColumns: {
      orderId: "Номер заказа",
      customerName: "Имя клиента",
      mobile: "Мобильный",
      paymentMethod: "Способ оплаты",
      shippingMethod: "Способ доставки",
      orderAmount: "Сумма заказа",
      orderTime: "Время заказа",
      status: "Статус",
      currency: "Риал",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "Название адреса",
      name: "Имя",
      family: "Фамилия",
      mobile: "Телефон",
      address: "Адрес",
      zipCode: "Почтовый индекс",
      number: "Номер дома",
      unit: "Квартира",
    },
    shippingType: {
      courier: "Курьер",
      reservation: "Бронирование столика",
      place: "Самовывоз",
      none: "-",
    },
    paymentType: {
      online: "Онлайн-оплата",
    },
    perPage: "Записей на странице",
    search: "Поиск",
    sortColumn: "Сортировать по",
    sortDirection: "Направление сортировки",
    sortDirectionDesc: "По убыванию",
    sortDirectionAsc: "По возрастанию",
    noStatus: "Статус не найден",
    status: {
      all: "Все",
      active: "Активен",
      inactive: "Неактивен",
    },
    fetchError: "Ошибка загрузки данных пользователя",
  },
  listCardHeader: {
    clear_filters: "Очистить фильтры",
    group_qr_renewal: "Массовое продление QR-кода",
    select_desired_duration: "Выберите желаемую продолжительность",
    total_count: "Общее количество",
    final_amount: "Итоговая сумма",
    ten_percent_vat_will_be_added: "Будет добавлен НДС 10%",
    pay_and_upgrade: "Оплатить и обновить",
    no_tariff_for_this_period: "Нет тарифов на этот период",
    one_month_renewal: "Продление на 1 месяц",
    three_month_renewal: "Продление на 3 месяца",
    six_month_renewal: "Продление на 6 месяцев",
    one_year_renewal: "Продление на 1 год",
    selected: "Выбрано",
    view: "Просмотр",
    details: "Детали",
    total_amount: "Общая сумма",
    discount: "Скидка",
    final_amount_with_discount: "Итоговая сумма со скидкой",
    add_qr: "Добавить QR",
    select_all: "Выбрать все",
    actions: "Действия",
    filter: "Фильтр",
    type_filter: "Фильтр типа",
    start_from: "Начинается с",
    search: "Поиск",
    id_search: "Поиск по ID",
    filter_user: "Фильтр пользователя",
    sort: "Сортировка",
    send_sms: "Отправить SMS",
    selected_pattern: "Выбранный шаблон:",
    send: "Отправить",
    newest: "Новейшие",
    oldest: "Старейшие",
    most_visited: "Самые посещаемые",
    least_visited: "Менее посещаемые",
    pause: "Пауза",
    bulk_download: "Массовое скачивание",
    activate: "Активировать",
    deactivate: "Деактивировать",
    error_loading_card: "Ошибка загрузки данных карты!",
    error_fetching_prices: "Ошибка получения цен!",
    error_payment: "Ошибка оплаты!",
    sms_success: "SMS успешно отправлено",
    generic_error: "Произошла ошибка!",
  },
  headerTypeFilter: {
    qr_model: "Модель QR",
    all_qr_models: "Все модели QR",
  },
  menuOrderFactor: {
    order_invoice: "Счет заказа",
    total: "Итого",
    tax: "Налог",
    shipping_cost: "Стоимость доставки",
    packing_cost: "Стоимость упаковки",
    discount: "Скидка",
    final_total: "Итоговая сумма",
    currency: "Риал",
    titles: {
      default_title: "Стандартный заказ",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "Поиск в списке",
    search: "Поиск",
    start_from: "Начинается с",
  },
  headerStatusFilter: {
    all_qr_codes: "Все QR-коды",
    active_qr_codes: "Активные QR-коды",
    inactive_qr_codes: "Неактивные QR-коды",
    expiring_qr_codes: "QR-коды, срок действия которых скоро истекает",
    expired_qr_codes: "Истекшие QR-коды",
  },
  qrOrdersList: {
    title: "Список заказов",
    orderColumns: {
      index: "Заказ",
      id: "Номер заказа",
      customerName: "Имя клиента",
      mobile: "Мобильный",
      paymentType: "Тип оплаты",
      shippingType: "Тип доставки",
      price: "Сумма заказа",
      createdAt: "Время заказа",
      status: "Статус",
      actions: "Действия",
    },
    productsColumns: {
      productId: "ID продукта",
      image: "Изображение",
      productName: "Название продукта",
      unitPrice: "Цена за единицу",
      quantity: "Количество",
      totalPrice: "Общая цена",
    },
    actions: {
      products: "Список заказа",
      print: "Печать заказа",
      share: "Поделиться заказом",
      status: "Изменить статус",
    },
    shippingType: {
      courier: "Курьер",
      reservation: "Бронирование столика",
      place: "Самовывоз",
      post: "Почтовая доставка",
      unknown: "-",
    },
    paymentType: {
      online: "Онлайн-оплата",
      place: "Оплата на месте",
      unknown: "-",
      card2card:"Перевод с карты на карту",
    },
    status: {
      all: "Все",
      pending: "Ожидание оплаты",
      accepted: {
        place: "Оплата на месте",
        paid: "Оплачено",
      },
      delivered: "Доставлено",
      rejected: "Оплата не удалась",
    },
    factorTitle: "Счет заказа",
    printFactor: "Печать счета",
    fetchError: "Ошибка загрузки данных",
    statusChanged: "Статус успешно изменен",
    statusChangeError: "Ошибка изменения статуса",
    currency: "Риал",
    perPage: "Количество",
    search: "Поиск",
    noStatus: "Нет статуса",
    loading: "Загрузка...",
    noShippingType: "Нет типа доставки",
    noPaymentType: "Нет типа оплаты",
    sortColumn: "Столбец сортировки",
    sortDirection: "Направление сортировки",
    sortDirectionDesc: "По убыванию",
    sortDirectionAsc: "По возрастанию",
    selectNewStatus: "Выбрать новый статус",
    changeStatusTitle: "Изменить статус",
    linkCopied: "Ссылка скопирована.",
  },
  qrUserTransfer: {
    title: "Передача владения",
    radioLabels: {
      userTransfer: "Передать другому лицу",
      givingAccess: "Предоставить доступ",
    },
    inputLabels: {
      phone: "Мобильный номер лица",
    },
    hints: {
      addNumber: "Нажмите Enter или + для добавления",
      addNumberStep2: "Нажмите Enter или + для добавления",
    },
    buttons: {
      transfer: "Передать",
      giveAccess: "Предоставить доступ",
      back: "Назад",
      saveChanges: "Сохранить изменения",
      cancel: "Отмена",
        "add": "Добавить"

    },
    tooltips: {
      deleteAccess: "Удалить доступ",
    },
    subtitles: {
      accessList: "Список авторизованных пользователей:",
      selectPermissions: "Выберите разрешения:",
    },
    permissionList: {
      edit_name: "Редактировать название сервиса",
      edit_link: "Редактировать ссылку",
      edit_info: "Редактировать информацию",
      edit_design: "Редактировать дизайн QR",
      edit_settings: "Редактировать настройки QR",
      toggle_access: "Включить/отключить доступ",
      view_customers: "Просмотр списка клиентов",
      view_orders: "Просмотр списка заказов",
    },
    messages: {
      invalidPhone: "Неверный номер телефона",
      duplicatePhone: "Дубликат номера не разрешен",
      updateAccessSuccess: "Доступ успешно обновлен.",
      updateAccessError: "Ошибка обновления: {message}",
      deleteAccessSuccess: "Доступ успешно удален.",
      deleteAccessError: "Ошибка удаления: {message}",
      fetchAccessError: "Ошибка загрузки: {message}",
      transferSuccess: "QR успешно передан.",
      transferError: "Ошибка передачи: {message}",
      giveAccessSuccess: "Успешно настроено.",
      giveAccessError: "Ошибка настройки: {message}",
      confirmDeleteAccess: "Действительно удалить доступ этого человека?",
    },
  },
  form: {
    form_download: "Полученные формы",
    form_add: "Добавить форму",
    formdownload: "Полученная форма",
    create_at: "Создано:",
    shown: "Показано",
    nogiveform: "У вас нет полученных форм",
    back: "Назад",
    invalid_date: "Неверная дата",
    select_date: "Выбрать дату",
    select: "Выбрать",
    clear: "Очистить",
    now: "Сейчас",
  },
  dsBasketCondition: {
    title: "Минимальные условия корзины",
    items: {
      NoConditions: "Без условий",
      MinimumShopping: "Минимальная сумма корзины",
      MinimumProduct: "Минимальное количество продуктов в корзине",
      MaximumShopping: "Максимальная сумма корзины",
      MaximumProduct: "Максимальное количество продуктов в корзине",
    },
  },
  dsUserSettings: {
    title: "Минимальные условия корзины",
    groupTitle: "Пользователи, которые",
    specialTitle: "Пользователи",
    labels: {
      minimumCart: "Минимальные условия корзины",
      users: "Пользователи",
    },
    items: {
      AllUser: "Все пользователи",
      group: "Группа пользователей",
      special: "Специальные пользователи",
    },
    groupItems: {
      Order: "Уже покупали",
      noOrder: "Еще не покупали",
    },
  },
  qrAddressUpdate: {
  title: "Изменить адрес",
  labels: {
    address: "QR-адрес",
  },
  hints: {
    allowedChars: "Разрешены только английские буквы, цифры, дефис (-) и подчёркивание (_)",
  },
  buttons: {
    removeInvalidChars: "Удалить недопустимые символы",
  },
  errors: {
    minLength: "Необходимо ввести минимум 3 символа",
    invalidChars: "Недопустимый символ! Используйте только английские буквы, цифры, - и _.",
    invalidAddress: "Введённый адрес недействителен",
    updateFailed: "Ошибка при обновлении адреса",
  },
  successMessage: "Адрес успешно обновлён",
  warning: "Предупреждение",
  warningMessage: "Изменение адреса приведёт к тому, что предыдущие ссылки перестанут работать.",
  savePrompt: "Вы уверены, что хотите сохранить это изменение?",
},
  dsFunctionType: {
    title: "Скидка применяется к",
    productListTitle: "Список продуктов",
    categoryListTitle: "Список категорий",
    labels: {
      applyDiscount: "Применить скидку к",
      category: "Категория",
    },
    items: {
      AllShoppingCart: "Общая сумма корзины",
      SpecialProducts: "Специальные продукты",
      SpecialCategories: "Специальные категории",
    },
  },
  dsLimitationUse: {
    title: "Ограничение использования",
    discountCodeTitle: "Использования кода",
    userTitle: "Использований на пользователя",
    labels: {
      limitation: "Ограничение",
      usage: "Использование",
      user: "Пользователь",
    },
    items: {
      NoLimitations: "Без ограничений",
      DiscountCode: "Использования кода скидки",
      User: "Использований на пользователя",
    },
  },
  ManageHourLimitQr: {
    noLimit: "Без лимита",
    dateLimit: "Ограничение по дате",
    timeLimit: "Ограничение по времени",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    selectDate: "Выбрать дату",
    startTime: "Время начала",
    endTime: "Время окончания",
  },
  discount_percent_range: "Скидка должна быть от 0 до 100%",
  discount_price_range: "Скидка должна быть от 0 до {max}",
  invalid_number: "Введите только числа",
  min_order_cart: "Минимальная сумма заказа",
  preparation_time: "Время приготовления (минуты)",
  delivery_time: "Время доставки (минуты)",
  max_product_in_order: "Макс. продуктов на заказ",
  max_order_by_person: "Макс. заказов на человека",
  send_by_courier_price: "Стоимость курьера",
  vat: "Ставка налога",
  send_by_post: "Стоимость почтовой доставки",
  online_pay: "Онлайн-оплата",
  pay_in_person_place: "Оплата на месте",
  in_place: "Самовывоз",
  table_booking_ability: "Бронирование столика",
  send_by_courier: "Доставка курьером",
  vat_switch: "Налог",
  invalid_number: "Введите только числа",
  positive_number: "Число должно быть положительным",
  vat_range: "Ставка налога должна быть от 0 до 100%",
  sort_column: "Столбец сортировки",
  direction_sort: "Направление сортировки",
  listFeedbackUser: {
    no_questions: "У вас нет вопросов для сбора отзывов",
    add_feedback_prompt: "Создайте новый отзыв во вкладке 'Добавить'",
    question_label: "Вопрос",
    show_answers: "Показать ответы",
    back_button: "Назад",
    no_feedback: "Отзывы недоступны!",
    user_opinion: "Мнение пользователя",
    score_label: "Оценка",
  },
  manageDiscount: {
    createNewDiscount: "Создать новый код скидки",
    copy: "Копировать",
    row: "Строка",
    id: "ID",
    discountCode: "Код скидки",
    usageLimit: "Лимит использования",
    used: "Использовано",
    manage: "Управление",
    edit: "Редактировать",
    delete: "Удалить",
    sendSms: "Отправить SMS целевой группе",
    copySuccess: "Код скидки скопирован",
    copyError: "Ошибка копирования",
    deleteSuccess: "Код скидки удален",
    deleteError: "Ошибка удаления кода скидки",
    smsSuccess: "Код скидки отправлен целевой группе",
    smsError: "Ошибка отправки",
  },
  manageTableReservation: {
    table: "Стол",
    number: "Стол {num}",
    add_table: "Добавить стол",
    complete_info_for_customer:
      "Заполните информацию, которая будет показана клиенту",
    select_image: "Выбрать изображение",
    table_name_number: "Название/номер стола",
    number_of_seats: "Количество мест",
    type: "Тип",
    reservation_cost: "Стоимость бронирования",
    enter_table_name: "Введите название/номер стола",
    table_type: "Стол",
    couch_type: "Диван",
    gazebo_type: "Беседка",
  },
  create_menu: {
    data: {
      visitName_label: "Название посещения",
      organizationName: "Крупная сеть фастфуда",
      subOrgan: "Попробуйте лучший вкус фастфуда с нами",
      aboutUs:
        "Крупный Фастфуд – с качеством и уважением к клиенту мы предлагаем лучшее.\nКачество – наш принцип.\nВ секторе фастфуда мы представили новый вкус миру быстрых блюд с нашими специальными сэндвичами.\nМы готовы каждый день обслуживать вас на административных мероприятиях, днях рождения и многом другом...",
      copyright: "Все права этого сайта принадлежат Terminal Advertising.",
      product: {
        title: "Продукты",
        pizzas: "Пиццы",
        pizza_roast_beef: "Пицца Ростбиф",
        pizza_roast_beef_desc: "🤩 Итальянская пицца с говядиной",
        pizza_roast_beef_ingredients:
          "Итальянская основа для пиццы 30 см, 100 г говяжьего фарша, грибы, перец, черные оливки",
        pizza_chicken_mushroom: "Пицца Курица и Грибы",
        pizza_chicken_mushroom_desc: "🍕 Классическая 40 см",
        pizza_chicken_mushroom_ingredients:
          "Свежий томатный соус Pizzara, пастеризованный сыр, куриное филе, грибы, горный тимьян",
        pizza_meat_mushroom: "Пицца Мясо и Грибы",
        pizza_meat_mushroom_desc: "🥰 Пицца с говяжьим фаршем и грибами",
        pizza_meat_mushroom_ingredients:
          "Свежий томатный соус Pizzara, пастеризованный сыр, фарш из говяжьей вырезки, грибы, горный тимьян, на 2 человека (29 см) 355 000 томанов, на 1 человека (22 см) 216 000 томанов",
        pizza_veggie: "Вегетарианская Пицца",
        pizza_veggie_desc: "🍕 Американская вегетарианская пицца",
        pizza_veggie_ingredients:
          "Американская основа для пиццы, сладкая кукуруза, грибы, оливки, помидоры, лук, перец, сыр для пиццы",
        pizza_special: "Специальная Пицца",
        pizza_special_desc: "Американская специальная пицца",
        pizza_special_ingredients:
          "Американская основа для пиццы, приправленный говяжий фарш, смесь гамбургера говядина и курица 80%, смесь моцареллы, специальный соус, перец, грибы, без соуса на 1 человека",
        pizza_bolognese: "Пицца Болоньезе",
        pizza_bolognese_desc: "(На 1 человека) Основа для пиццы 23 см 🤌",
        pizza_bolognese_ingredients:
          "Говяжий фарш, моцарелла, грибы, перец, сладкая кукуруза, нарезанные черные оливки",
        pizza_pepperoni: "Пицца Пепперони",
        pizza_pepperoni_desc: "(На 1 человека) Основа для пиццы 23 см",
        pizza_pepperoni_ingredients:
          "Итальянская основа для пиццы, пепперони 80%, соус маринара, специальный сыр для пиццы",
        pizza_bacon: "Пицца Бекон",
        pizza_bacon_desc: "(На 1 человека) Основа для пиццы 23 см 💥",
        pizza_bacon_ingredients:
          "Итальянская основа для пиццы, соус маринара, специальный сыр для пиццы, бекон смесь говядина и курица 90%, грибы, оливки, перец",
        pizza_mixed: "Смешанная Пицца",
        pizza_mixed_desc: "(На 1 человека) Основа для пиццы 23 см 🤭",
        pizza_mixed_ingredients:
          "Смесь гамбургера говядина и курица фарш, салями, говяжий фарш, грибы, оливки, перец, сыр для пиццы, специальный соус",
        pizza_american_steak: "Американская Пицца Стейк",
        pizza_american_steak_desc: "(На 1 человека) 23 см 💥",
        pizza_american_steak_ingredients:
          "Американская основа для пиццы, кусочки говядины, грибы, сыр для пиццы, кунжут",
        burgers: "Бургеры",
        cheeseburger: "Чизбургер",
        cheeseburger_desc: "🤩 С картошкой фри",
        cheeseburger_ingredients:
          "2 котлеты для бургера из говядины по 150 г, специальный соус, сыр Гауда, соленый огурец, салат, помидор",
        hamburger: "Гамбургер",
        hamburger_desc: "😍 Чистая говядина со специальным соусом",
        hamburger_ingredients:
          "Котлета для бургера из говядины 150 г, соленый огурец, салат, специальный соус, помидор, булочка Mac, соус на 1 человека",
        chicken_burger: "Куриный Бургер",
        chicken_burger_desc: "Жареная курица с сыром",
        chicken_burger_ingredients:
          "150 г жареной куриной грудки, сыр, помидор, соленый огурец, салат, булочка Mac, специальный соус",
        spice_burger: "Острый Бургер",
        spice_burger_desc: "Говядина с острым соусом",
        spice_burger_ingredients:
          "Котлета для бургера из говядины 130 г, острый соус, салат, помидор, булочка Mac, специальный острый соус",
        double_burger: "Двойной Бургер",
        double_burger_desc: "Говядина 150 г",
        double_burger_ingredients:
          "2 ручные котлеты из говядины по 150 г, сыр для пиццы, карамельный соус, салат, красная капуста, белый специальный соус, круглая булочка",
        royal_burger: "Королевский Бургер",
        royal_burger_desc: "150 г говядины 🍔",
        royal_burger_ingredients:
          "Ручная котлета из говядины 150 г, сыр для пиццы, 5 ломтиков салями, карамельный соус, салат, красная капуста, белый специальный соус, круглая булочка",
        mushroom_burger: "Грибной Бургер",
        mushroom_burger_desc: "Говядина 150 г",
        mushroom_burger_ingredients:
          "Ручная котлета из говядины 150 г, грибы, карамельный соус, салат, красная капуста, белый специальный соус, круглая булочка, моцарелла",
        mashroom_burger: "Грибной Бургер",
        mashroom_burger_desc: "100% жареная говядина 🤩",
        mashroom_burger_ingredients:
          "Ручная 100% жареная котлета из говядины, картошка фри, помидор, салат, соленый огурец, грибной соус, круглая булочка",
        fried_burger: "Жареный Бургер",
        fried_burger_desc: "100% жареная и обжаренная говядина 👌",
        fried_burger_ingredients:
          "Ручная 100% жареная и обжаренная котлета из говядины, 150 г картошки фри, помидор, салат, соленый огурец, специальный соус, круглая булочка",
        fried: "Жареное",
        fried_chicken: "Жареная Курица",
        fried_chicken_desc: "😍 3 куска жареной курицы",
        fried_chicken_ingredients:
          "3 куска жареной курицы, 120–150 г фри, 100–120 г салата коулсло, булочка, специальный соус",
        chicken_strips: "Куриные Стрипсы",
        chicken_strips_desc:
          "4 куска приправленного острого жареного куриного филе",
        chicken_strips_ingredients:
          "4 куска жареного куриного филе, 120–150 г фри, 100–120 г коулсло, булочка, соус тартар",
        fried_filet: "Жареное Филе",
        fried_filet_desc: "🤩 2 куска жареного филе со специальным соусом",
        fried_filet_ingredients:
          "2 куска стрипсов, жареный картофель, коулсло, булочка, чесночный соус, тайский чили соус, соус паприка",
        fried_mushroom_onion: "Жареные Грибы и Лук",
        fried_mushroom_onion_desc: "🤩 Жареные грибы и лук с соусом тартар",
        fried_mushroom_onion_ingredients:
          "20 штук жареных грибов, 6 штук жареных луковых колец, соус тартар",
        fried_wings: "Жареные Крылышки",
        fried_wings_desc: "6 штук жареных крылышек 🍗",
        fried_wings_ingredients: "Шесть жареных и обжаренных крылышек",
        fried_chicken_basket: "Корзина Жареной Курицы",
        fried_chicken_basket_desc: "(На 2 человека) 😍",
        fried_chicken_basket_ingredients:
          "2 куска жареной курицы, 2 куска стрипсов, 2 куска луковых колец, 2 куска жареных креветочных наггетсов, 2 куска куриных наггетсов",
        fried_schnitzel: "Жареный Шницель",
        fried_schnitzel_desc: "Четыре куска куриного шницеля 💥",
        fried_schnitzel_ingredients:
          "Четыре жареных и обжаренных приправленных куриных шницеля",
        veggie_basket_fried: "Жареная Вегетарианская Корзина",
        veggie_basket_fried_desc: "250 г 🤩",
        veggie_basket_fried_ingredients:
          "250 г, жареный кабачок, баклажан, грибы, картофель",
        fried_chicken_2_piece: "Жареная Курица 2 Куска",
        fried_chicken_2_piece_desc: "2 куска жареной курицы 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150 г фри, 100–120 г коулсло, булочка, специальный соус",
        fried_chicken_5_piece: "Жареная Курица 5 Кусков",
        fried_chicken_5_piece_desc: "Пять кусков жареной курицы",
        fried_chicken_5_piece_ingredients:
          "150–200 г фри, два коулсло 100–120 г, две булочки, специальный соус",
        fried_chicken_7_piece: "Жареная Курица 7 Кусков",
        fried_chicken_7_piece_desc: "Семь кусков жареной курицы 💥",
        fried_chicken_7_piece_ingredients:
          "150–200 г фри, коулсло 100–120 г, 3 булочки, специальный соус, соус на 1 человека жареный",
        sandwich: "Сэндвич",
        hotdog_sandwich: "Сэндвич Хотдог",
        hotdog_sandwich_desc: "Сэндвич хотдог с грибами и сыром",
        hotdog_sandwich_ingredients:
          "Жареная сосиска для хотдога, салат, помидор, соленый огурец, грибы и сыр для пиццы",
        roast_beef_sandwich: "Сэндвич Ростбиф",
        roast_beef_desc: "✔️ Фарш из говядины",
        roast_beef_ingredients:
          "Говядина, сыр для пиццы, грибы, нарезанные чипсы из картофеля, салат, помидор, соленый огурец, специальный соус, французский хлеб",
        ham_sandwich: "Сэндвич Хэм",
        ham_sandwich_desc: "Сэндвич с куриным хэмом и грибами (холодный)",
        ham_sandwich_ingredients:
          "Куриный хэм с грибами, салат, помидор, соленый огурец, нарезанные чипсы из картофеля, специальный соус, багет",
        bandari_sausage_sandwich: "Сэндвич Сосиска Бандари",
        bandari_sausage_sandwich_desc: "💥 Острый сэндвич Бандари",
        bandari_sausage_sandwich_ingredients:
          "Блюдо Бандари с копченой коктейльной сосиской 55%, помидор, соленый огурец, специальный соус, лук и кориандр, объемный хлеб",
        tongue_mushroom_sandwich: "Сэндвич Язык и Грибы",
        tongue_mushroom_sandwich_desc: "150 г говяжьего языка",
        tongue_mushroom_sandwich_ingredients:
          "Грибы, пастеризованный сыр для пиццы, оливки, сладкая кукуруза, салат, соленый огурец, помидор, соус, гарниры, фри, коулсло",
        falafel_sandwich: "Сэндвич Фалафель",
        falafel_sandwich_desc: "Шесть штук фалафеля 🌭",
        falafel_sandwich_ingredients:
          "Шесть штук фалафеля, соленый огурец, помидор, салат, соус на 1 человека, гарниры, фри, коулсло",
        cheesy_kebab_turki_sandwich: "Сырный Турецкий Кебаб Сэндвич",
        cheesy_kebab_turki_sandwich_desc: "150 г говядины",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 г говядины, специальный сыр для пиццы, соленый огурец, помидор, салат, соус на 1 человека, фри, коулсло",
        roast_chicken_sandwich: "Жареный Куриный Сэндвич",
        roast_chicken_sandwich_desc: "Куриный шницель и грибы 🤩",
        roast_chicken_sandwich_ingredients:
          "Куриный шницель и грибы, специальный сыр для пиццы, оливки, сладкая кукуруза, кунжут, салат, перцы, соленый огурец, помидор, специальный соус, гарниры, фри",
        cheesy_indian_sandwich: "Индийский Сырный Сэндвич",
        cheesy_indian_sandwich_desc: "Немецкая сосиска 💥",
        cheesy_indian_sandwich_ingredients:
          "Немецкая сырная сосиска, сладкая кукуруза, салат, грибы, специальный соус, гарниры, фри, коулсло",
        snack: "Снэк",
        chicken_snack: "Куриный Снэк",
        chicken_snack_desc: "😋 Фарш из куриной грудки",
        chicken_snack_ingredients:
          "150 г куриной грудки, перцы, грибы, специальный хлеб для снэка, специальный соус",
        meat_snack: "Мясной Снэк",
        meat_snack_desc: "🥪 Двойной мясной снэк",
        meat_snack_ingredients:
          "Двойной, фарш из говяжьей вырезки, моцарелла, сладкая кукуруза, перцы, специальный соус, тостовый хлеб",
        chicken_meat_snack: "Курино-Мясной Снэк",
        chicken_meat_snack_desc: "🤩 Двойной курино-мясной снэк",
        chicken_meat_snack_ingredients:
          "Двойной, фарш из куриной грудки, фарш из говяжьей вырезки, моцарелла, сладкая кукуруза, перцы, специальный соус, тостовый хлеб",
        special_snack: "Специальный Снэк",
        special_snack_desc: "🤤 Двойной специальный снэк",
        special_snack_ingredients:
          "Двойной, смесь колбасы говядина и курица 90%, моцарелла, сладкая кукуруза, перцы, специальный соус, тостовый хлеб",
        roast_beef_snack: "Ростбиф Снэк",
        roast_beef_snack_desc: "Фарш из говядины 🍖",
        roast_beef_snack_ingredients:
          "Фарш из говядины, грибы, сыр для пиццы, перцы, сладкая кукуруза, гарниры, фри, коулсло",
        veggie_snack: "Вегетарианский Снэк",
        veggie_snack_desc: "4 куска вегетарианского снэка",
        veggie_snack_ingredients:
          "Брокколи, сладкая кукуруза, оливки, диетический сыр для пиццы, грибы, гарниры, фри, коулсло",
        chicken_mushroom_snack: "Курица и Грибы Снэк",
        chicken_mushroom_snack_desc: "Куриный шницель и грибы 👌",
        chicken_mushroom_snack_ingredients:
          "Куриный шницель, грибы, специальный сыр для пиццы, оливки, сладкая кукуруза, перцы, гарниры, фри, коулсло",
        pepperoni_snack: "Пепперони Снэк",
        pepperoni_snack_desc: "Колбаса пепперони 90% 💥",
        pepperoni_snack_ingredients:
          "Двойной, колбаса пепперони 90%, моцарелла, сладкая кукуруза, перцы, специальный соус",
        bologna_snack: "Болонья Снэк",
        bologna_snack_desc: "Фарш из говядины 👌",
        bologna_snack_ingredients:
          "Двойной, фарш из говядины, специальный бекон, отбеленные грибы, сладкая кукуруза, моцарелла, перцы, специальный соус",
        pasta: "Паста",
        alfredo_pasta: "Паста Альфредо",
        alfredo_pasta_desc: "Паста Альфредо со специальным грибным соусом",
        alfredo_pasta_ingredients: "350 г пенне",
        macaroni: "Макароны",
        macaroni_desc: "🥣 Макароны с мясом и грибами",
        macaroni_ingredients:
          "Ленточные макароны 1,2, 100 г говяжьего фарша, грибы, перцы, нарезанный жареный картофель, горох",
        spaghetti_bolognese: "Спагетти Болоньезе",
        spaghetti_bolognese_desc: "🥰 Паста лингуине",
        spaghetti_ingredients:
          "700 г, паста лингуине, фарш из говядины и баранины, соус болоньезе, специальный красный соус Расу, пластиковая ложка и вилка опционально",
        chicken_stroganoff: "Куриный Строганов",
        chicken_stroganoff_desc:
          "😍 Куриный строганов с кусочками куриной грудки",
        chicken_stroganoff_ingredients:
          "180 г приправленных кусочков куриной грудки, сливки, отбеленные грибы, пармезан, нарезанная вручную фри, специальный контейнер для микроволновки",
        penne_arrabbiata: "Пенне Арабьята",
        penne_arrabbiata_desc: "Куриная грудка 💥",
        penne_arrabbiata_ingredients:
          "На 1 человека, куриная грудка, паста, грибы, пармезан, помидоры черри, петрушка, соус арабьята",
        chicken_pesto_pasta: "Паста Песто с Курицей",
        chicken_pesto_pasta_desc: "(На 1 человека) Куриная грудка",
        chicken_pesto_pasta_ingredients:
          "Куриная грудка, грибы, пармезан, помидоры черри, петрушка, соус арабьята",
        carbonara_pasta: "Паста Карбонара",
        carbonara_pasta_desc: "Бекон из говядины 97%",
        carbonara_pasta_ingredients:
          "Паста, бекон из говядины 97%, соус альфредо, пармезан, помидоры черри, петрушка",
        appetizer: "Закуски",
        hot_chips: "Горячие Чипсы",
        hot_chips_desc: "😙 Разные вкусы чипсов",
        hot_chips_ingredients:
          "Кило чипсов, специальный соус, куриный хэм 70%, грибы, перцы, сыр для пиццы, Гауда",
        lasagna: "Лазанья",
        lasagna_desc: "Лазанья с говяжьим фаршем",
        lasagna_ingredients:
          "3 листа лазаньи, говяжий фарш, грибы, перцы, черные оливки, сыр для пиццы, специальный соус",
        french_fries: "Картофель фри",
        french_fries_desc: "Картофель фри с фирменным соусом",
        french_fries_ingredients: "150 г картофеля фри, фирменный соус",
        baked_potato: "Запечённый картофель",
        baked_potato_desc: "🍟 Запечённый картофель с беконом из говядины",
        baked_potato_ingredients:
          "150 г картофеля фри, бекон из говядины 90%, сыр для пиццы, фирменные специи, соус на одну персону",
        garlic_bread: "Чесночный хлеб",
        garlic_bread_desc: "Фирменный чесночный соус💥",
        garlic_bread_ingredients:
          "Американское тесто для пиццы, смесь сыра для пиццы, фирменный чесночный соус, кунжут",
        silo_potatoes: "Картофель Сило",
        silo_potatoes_desc: "Картофель фри на двоих",
        silo_potatoes_ingredients:
          "Картофель фри со специями Сило, бекон из говядины 97%, соус чеддер, айоли, зелёный лук, петрушка",
        bbq_sausage: "Сосиски барбекю",
        bbq_sausage_desc: "Маринованные сосиски-пальчики🍢",
        bbq_sausage_ingredients:
          "500 г приправленного картофельного пюре, 200 г маринованных сосисок-пальчиков, кольца лука, зелёные оливки, сыр пармезан в порошке, черри, микрозелень, сыр для гриля, соус барбекю, острый",
        silo_toast: "Тост Сило",
        silo_toast_desc: "160 г нарезанной говяжьей вырезки🤩",
        silo_toast_ingredients:
          "160 г нарезанной говяжьей вырезки, французский салат, бекон из говядины, фермерский хлеб, соус барбекю, тартар, щавель, зелёные оливки, микрозелень, айоли, сыр пармезан в порошке",
        salad_and_dessert: "Салаты и десерты",
        caesar_salad: "Салат Цезарь",
        caesar_salad_desc: "Салат Цезарь на одного🥗",
        caesar_salad_ingredients:
          "Смесь салатов, курица-гриль, сыр пармезан, крутоны (чесночный хлеб), соус Цезарь, оливки",
        caesar_salad_extra: "Салат романо, крутоны, пармезан",
        coleslaw_salad: "Салат из капусты",
        coleslaw_salad_desc: "Салат из капусты на одного🍴",
        coleslaw_salad_ingredients:
          "Ручная работа, на одного, белокочанная капуста, кукуруза, соус",
        macaroni_salad: "Салат с макаронами",
        macaroni_salad_desc: "Салат с макаронами и домашней колбасой",
        macaroni_salad_ingredients: "Макароны, домашняя колбаса",
        pachira_salad: "Салат Пачира",
        pachira_salad_desc: "Салат Пачира на двоих🥗",
        pachira_salad_ingredients:
          "На двоих, смесь салатов, чипсы из бекона 98%, карамелизованные грецкие орехи, сыр пармезан, клубника, растительная икра, изюм, ломтики лимона, соус розовая ягода",
        greek_salad: "Греческий салат",
        greek_salad_desc:
          "Традиционный греческий салат с сыром фета и оливками",
        greek_salad_ingredients: "Сыр фета, оливки, огурец",
        tiramisu: "Тирамису",
        tiramisu_desc: "Классический итальянский десерт тирамису",
        tiramisu_ingredients: "Кофе, маскарпоне, какао",
        beverages: "Напитки",
        local_yogurt_drink: "Местный айран",
        local_yogurt_drink_desc: "Семейный местный айран🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "Чёрная газировка",
        black_soda_desc: "Чёрная газировка в стакане🧋",
        black_soda_ingredients: "",
        fanta: "Жёлтая газировка",
        fanta_desc: "Жёлтая газировка в стакане🥤",
        fanta_ingredients: "",
        mojito: "Мохито",
        mojito_desc: "Мохито в стакане 350–400 мл🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "Тропический солодовый напиток",
        tropical_malt_beverage_desc:
          "Тропический солодовый напиток в стакане🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "Адрес",
        address_text: "Введите ссылку на желаемый сайт",
        instagram_label: "Instagram",
        instagram_text: "Введите ваше имя пользователя",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "Видеогалерея",
        description:
          "Для более подробного ознакомления с услугами интеллектуальной системы QR-Land просмотрите видео ниже.",
        tutorial: "Обучающее",
        fast_food: "Фастфуд",
      },
      feedback: {
        title: "Ваш отзыв",
        description:
          "Пожалуйста, ответьте на вопросы ниже, чтобы помочь нам улучшить услуги",
        question1: "Насколько вы довольны нашими услугами и качеством еды?",
        question2: "Как вы оцениваете разнообразие блюд в ресторане?",
        question3: "Как вы оцениваете поведение персонала ресторана?",
        question4: "Была ли еда доставлена вовремя?",
        question5:
          "Есть ли у вас предложения по улучшению услуг или качества еды?",
      },
      worksheet: {
        saturday: "Суббота",
        sunday: "Воскресенье",
        monday: "Понедельник",
        tuesday: "Вторник",
        wednesday: "Среда",
        thursday: "Четверг",
        friday: "Пятница",
        shift_1_saturday: "10:00 – 22:00",
        shift_1_sunday: "10:00 – 22:00",
        shift_1_monday: "10:00 – 22:00",
        shift_1_tuesday: "10:00 – 22:00",
        shift_1_wednesday: "10:00 – 00:00",
        shift_1_thursday: "10:00 – 00:00",
        shift_1_friday: "10:00 – 00:00",
      },
      gallery: {
        gallery_0: "Галерея 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "Запечённый картофель 2",
        chicken_stroganoff_1: "Чикен строганов 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "Тегеран, улица Шариати, после моста Сейед Хандан, тупик Хандан, дом 6, квартира 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "Иран, Тегеран, город Тегеран, Тегеран, район 3 города Тегеран, район Сейед Хандан, доктор Али Шариати, Хандан",
      },
    },
    messages: {
      qr_created_success: "Онлайн-меню успешно создано.",
      qr_updated_success: "QR-код вашего онлайн-меню успешно отредактирован.",
      qr_create_error: "Ошибка при создании QR!",
      qr_update_error: "Ошибка при сохранении/редактировании QR",
      template_categories_saved:
        "Категории шаблонной модели успешно сохранены.",
      template_products_saved: "Продукты шаблонной модели успешно сохранены.",
      template_categories_error:
        "Ошибка при сохранении категорий шаблонной модели!",
      template_products_error:
        "Ошибка при сохранении продуктов шаблонной модели!",
    },
    sample_menu: "Примерное меню",
    view_qr: "Просмотр QR",
    preview: "Предпросмотр",
    download_qr: "Скачать QR",
    create_qr: "Создать QR",
    online_menu_name: "Название онлайн-меню",
    online_menu_name_short: "Название меню",
    enter_qr_address: "Введите адрес QR",
    qr_address: "Адрес QR",
    enter_menu_information: "Введите информацию о меню",
    cleardefaults: "Очистить значения по умолчанию",
    select_sample_menu: "Выбрать примерное меню",
    select_ready_menu: "Выбрать готовое меню",
    online_sales: "Онлайн-продажи",
    sales_settings: "Настройки продаж",
    download: "Скачать",
    gallery_photos: "Фотографии галереи",
    fast_food_1: "Изображение фастфуда 1",
    fast_food_2: "Изображение фастфуда 2",
    large_chain_fast_food: "Крупная сеть фастфуда",
    best_fast_food_taste_experience: "Испытайте лучший вкус фастфуда с нами",
    online_menu_created_successfully: "Онлайн-меню успешно создано.",
    qr_creation_failed: "Ошибка при создании QR!",
    online_menu_qr_updated_successfully:
      "QR-код вашего онлайн-меню успешно отредактирован.",
    error_saving_updating_qr: "Ошибка при сохранении/редактировании QR",
    sample_model_categories_saved_successfully:
      "Категории шаблонной модели успешно сохранены.",
    sample_model_products_saved_successfully:
      "Продукты шаблонной модели успешно сохранены.",
    error_saving_sample_model_products:
      "Ошибка при сохранении продуктов шаблонной модели!",
    error_saving_sample_model_categories:
      "Ошибка при сохранении категорий шаблонной модели!",
  },
  editMenu: {
    enter_menu_information: "Введите информацию о меню",
    online_menu_name: "Название онлайн-меню",
    online_menu_name_short: "Короткое название онлайн-меню",
    fields: {
      qr_address_hint: "Адрес QR для доступа к онлайн-меню",
    },
    online_sales: "Онлайн-продажи",
    sales_settings: "Настройки продаж",
    shop: {
      upload_banner: "Загрузить баннер",
      create_product: "Создать продукт",
      user_info: "Информация о пользователе",
      add_social_media: "Добавить социальные сети",
      photo_gallery: "Фотогалерея",
      video_gallery: "Видеогалерея",
      feedback: "Отзыв",
      working_hours: "Часы работы",
    },
    success_message: "Ваша визитная карточка успешно отредактирована.",
  },
  qrCodeSquare: {
    dots_color: "Цвет точек",
    gradient_color: "Градиентный цвет",
    linear: "Линейный",
    radial: "Радиальный",
    color_rotation: "Поворот цвета",
    first_color: "Первый цвет",
    second_color: "Второй цвет",
    dots_color_label: "Цвет точек",
  },

  language: {
    selectAll: "Выбрать все",
    lang: {
      fa: "Персидский",
      ar: "Арабский",
      ar_ae: "Арабский (ОАЭ)",
      ar_iq: "Арабский (Ирак)",
      en_US: "Английский (США)",
      en_GB: "Английский (Великобритания)",
      de: "Немецкий",
      fr: "Французский",
      zh_CN: "Упрощённый китайский",
      zh_TW: "Традиционный китайский",
      tr: "Турецкий",
      ru: "Русский",
      hy: "Армянский",
    },
    only_manual_now: "Сейчас доступен только ручной перевод",
    ai_coming_soon: "Перевод с ИИ скоро будет включён",
    got_it: "Понял",
    origin_language: "Исходный язык",
    target_languages: "Целевые языки",
    remove_all: "Удалить все языки",
    translation_method: "Выберите метод перевода",
    manual_translation: "Ручной перевод",
    ai_translation: "Перевод с ИИ",
    coming_soon: "Скоро",
    source_language_updated: "Исходный язык обновлён",
    error_changing_source_language: "Ошибка при смене исходного языка",
    source_language_created: "Создан новый исходный язык",
    languages_saved: "Новые языки сохранены",
    error_saving_languages: "Ошибка сохранения языков",
    error_loading_language: "Ошибка загрузки языка",
    languages_removed: "Удалённые языки",
    new_languages_to_save: "Новые языки для сохранения",
    saved: "Сохранено",
    management_langs: "Управление языками",
    add_langs: "Добавить язык",
    change_language: "Сменить язык",
    visit_card: "Визитная карточка",
    translate_to: "Перевести на",
    main_language: "язык",
    no_languages_available: "Нет доступных языков",
    return_to_default: "Вернуться к языку по умолчанию",
    translate: "Перевести",
    changes_pending: "Ожидание применения изменений",
    apply_changes: "Применить изменения",
    cancel_changes: "Отмена",
  },
  winner_list: "Список победителей",
  qrwinnersList: {
    winnerstotalcount: "Общее количество победителей для QR",
    winnerscountoffilter: "Количество победителей с применённым фильтром",
    winnersList: "Список победителей QR",
    prize: "Приз",
    winnerName: "Имя победителя",
    date: "Дата",
    noWinners: "Победителей нет",
    perPage: "Строк на странице",
    search: "Поиск по имени или призу",
    sortDirection: "Направление сортировки",
    sortBy: "Сортировать по",
  },
  appearance_settings: "Настройки внешнего вида",
  header_color: "Цвет заголовка",
  background_color: "Цвет фона",
  text_color: "Цвет текста",
  font_size: "Размер шрифта",
  chat_logo: "Логотип чата",
  floating_button_icon: "Иконка плавающей кнопки",
  assistant_name: "Имя помощника",
  chat_preview: "Предпросмотр чата",
  smart_assistant: "Умный помощник",
  online: "Онлайн",
  aiChatSettings: {
    select_assistant: "Выбрать ассистента",
    appearance_settings: "Настройки внешнего вида",
    lead_connection_tab: "Сбор лидов — Подключение к клубу клиентов",

    header_settings: "Настройки заголовка",
    header_settings_desc: "Цвет и стиль заголовка чата",
    text_settings: "Настройки текста",
    text_settings_desc: "Цвет и размер шрифта",
    logo_settings: "Настройки логотипа",
    logo_settings_desc: "Фото или иконка ассистента",
    background_settings: "Настройки фона",
    background_settings_desc: "Фоновое изображение или цвет",

    gradient_color: "Градиентный цвет",
    solid_color: "Сплошной цвет",
    use_image: "Использовать изображение",
    use_icon: "Использовать иконку",

    first_color: "Первый цвет",
    second_color: "Второй цвет",
    header_color: "Цвет заголовка",
    text_color: "Цвет текста",
    background_color: "Цвет фона",

    font_size: "Размер шрифта",

    robot: "Робот",
    chat: "Чат",
    support: "Поддержка",
    question: "Вопрос",
    message: "Сообщение",
    assistant_voice: "Ассистент",
    ai_brain: "Искусственный интеллект",

    lead_connection_title: "Подключение к клубу клиентов",
    lead_alert:
      "Установка этих параметров позволит сохранять данные пользователя в клубе клиентов при выборе отправки лида.",

    hasAssistantsName_label: "Получать имя",
    hasAssistantsName_hint: "Запрашивать имя пользователя",
    hasAssistantsFamily_label: "Получать фамилию",
    hasAssistantsFamily_hint: "Запрашивать фамилию пользователя",
    hasAssistantsMobile_label: "Получать мобильный номер",
    hasAssistantsMobile_hint: "Запрашивать мобильный номер пользователя",
  },
  assistantChatViewer: {
    assistant_name: "Умный ассистент",
    online: "Онлайн",
    new_chat: "Новый чат",
    clear_chat: "Очистить чат",
    close: "Закрыть",
    message_placeholder: "Сообщение...",
    processing: "Обработка...",
    renew: "Продлить",
    created_at: "Создано",
    last_edit: "Последнее редактирование",
    copied: "Скопировано",
    copy: "Копировать",
    print_qr: "Печать QR",
    print_visit_card: "Печать визитной карточки",
    send_link: "Отправить ссылку",
    winner_list: "Список победителей",
    customer_list: "Список клиентов",
    order_list: "Список заказов",
    reserved_appointments: "Зарезервированные встречи",
    feedback: "Отзыв",
    request_form: "Форма заявки",
    transfer_ownership: "Передача права собственности",
    store_management: "Управление магазином",
    select_nfc_card: "Выбрать NFC-карту",
    edit: "Редактировать",
    design: "Дизайн",
    qr_settings: "Настройки QR",
    deactivate: "Деактивировать",
    download: "Скачать",
    viewed: "Просмотрено раз",
    see_more: "Подробнее",
    updating_qr: "Обновление QR...",
  },
  // ─────────────────────────────────────────────────────
  // Ключи перевода для раздела игры, GIF и настроек
  // Файл: src/core/services/langs/ru.js
  // Язык: Русский (стандартный)
  // ─────────────────────────────────────────────────────
  // 1. Основной редактор игры (PublicGameEditor)
  game_editor: "Редактор игры",
  reset_defaults: "Сбросить на значения по умолчанию",
  save_and_preview: "Сохранить и просмотреть",
  texts: "Тексты",
  images: "Изображения",
  colors: "Цвета",
  general_settings: "Общие настройки",
  gameplay_settings: "Настройки геймплея",
  effects: "Эффекты",
  login_and_phone: "Вход и номер телефона",
  no_settings_available_for_this_game_type:
    "Для этого типа игры нет доступных настроек",
  confirm_reset: "Подтвердить сброс",
  reset_all_settings_to_default:
    "Вы уверены, что хотите сбросить все настройки на значения по умолчанию?",
  yes_reset: "Да, сбросить",
  cancel: "Отмена",
  settings_reset_successfully: "Настройки успешно сброшены",
  saved_and_ready_for_preview: "Сохранено и готово к просмотру",

  // 2. Вкладка Вход и телефон (TabLogin)
  login_and_phone_settings: "Настройки входа и номера телефона",
  ask_phone_after_game: "Запрашивать номер телефона после игры",
  phone_prompt_text: "Текст запроса номера телефона",
  phone_prompt_hint: "Текст, отображаемый в диалоге запроса номера телефона",
  submit_button: "Кнопка отправки",
  login_dialog_logo: "Логотип диалога входа",
  logo_url: "URL логотипа",

  // 3. Вкладка Эффекты (TabEffect)
  game_effects_settings: "Настройки эффектов игры",
  sound_enabled: "Включить звук",
  volume: "Громкость",
  volume_hint: "Уровень громкости игры (от 0 до 1)",
  oscillator_type: "Тип осциллятора",
  jump_sound_freq: "Частота звука прыжка",
  hit_sound_freq: "Частота звука столкновения",
  powerup_sound_freq: "Частота звука усиления",
  move_sound_freq: "Частота звука движения",
  combo_base_freq: "Базовая частота комбо",
  sound_durations: "Длительность звуков",
  move_duration_ms: "Длительность звука движения (мс)",
  jump_duration_ms: "Длительность звука прыжка (мс)",
  combo_duration_ms: "Длительность звука комбо (мс)",
  hit_duration_ms: "Длительность звука столкновения (мс)",
  vibration_enabled: "Включить вибрацию",
  particles_enabled: "Включить частицы",
  explosion_settings: "Настройки взрыва частиц",
  particle_count: "Количество частиц",
  gravity: "Гравитация",
  friction: "Трение",
  fade_speed: "Скорость затухания",

  // 4. Вкладка Изображения (TabImages)
  game_images_and_assets: "Изображения и ресурсы игры",
  player_image: "Изображение игрока",
  player: "Игрок",
  powerup_image: "Изображение усиления",
  qr_powerup: "QR-усиление",
  enemy_images: "Изображения врагов",
  optional_multi: "Опционально, несколько изображений",
  enemies: "Враги",
  background_image: "Изображение фона",
  background: "Фон",
  phone_frame_background: "Фон рамки телефона",
  phone_frame: "Рамка телефона",
  winner_background: "Фон победителя",
  winner: "Победитель",
  ground_image: "Изображение земли",
  ground: "Земля",
  player_character: "Персонаж игрока",
  far_background_layer: "Дальний слой фона",
  background_far: "Дальний фон",
  near_background_layer: "Ближний слой фона",
  background_near: "Ближний фон",
  obstacle_images: "Изображения препятствий",
  multi_optional: "Несколько изображений, опционально",
  obstacles: "Препятствия",

  // 5. Вкладка Тексты (TabTexts)
  game_text_contents: "Текстовое содержимое игры",
  main_screen_texts: "Тексты главного экрана",
  game_title: "Название игры",
  game_subtitle: "Подзаголовок игры",
  start_button: "Кнопка старта",
  score_label: "Метка очков",
  game_over_screen: "Экран окончания игры",
  game_over_title: "Заголовок окончания игры",
  game_over_subtitle: "Подзаголовок окончания игры",
  phone_prompt: "Запрос номера телефона",
  restart_button: "Кнопка перезапуска",
  hud_and_labels: "HUD и метки",
  level_label: "Метка уровня",
  combo_label: "Метка комбо",
  final_score_label: "Метка финального счёта",
  high_score_label: "Метка рекорда",
  messages_and_popups: "Сообщения и всплывающие окна",
  new_record_message: "Сообщение о новом рекорде",
  fun_random_messages: "Забавные случайные сообщения",
  add_new_message: "Добавить новое сообщение",

  // 6. Вкладка Общие настройки (TabSetting)
  general_game_settings: "Общие настройки игры",
  enemy_spawn_rate: "Частота появления врагов",
  frames_between_enemies_spawn: "Кадры между появлением врагов",
  powerup_spawn_rate: "Частота появления усилений",
  frames_between_qr_spawn: "Кадры между появлением QR",
  win_score_threshold: "Порог очков для победы",
  score_required_for_win_or_phone_prompt:
    "Очки, необходимые для победы или показа запроса телефона",
  starting_lives: "Начальное количество жизней",
  high_score_storage_key: "Ключ хранения рекорда",
  phone_prompt_score_threshold: "Порог очков для запроса телефона",
  score_to_show_phone_number_form: "Очки для показа формы номера телефона",
  no_general_settings_available_for_this_game:
    "Для этой игры нет общих настроек",

  // 7. Вкладка Геймплей (TabGamePlay)
  speed_settings: "Настройки скорости",
  initial_speed: "Начальная скорость",
  max_speed: "Максимальная скорость",
  speed_increase_every_frames: "Увеличение скорости каждые X кадров",
  speed_increase_amount: "Величина увеличения скорости",
  distance_per_level: "Расстояние на уровень",
  level_speed_increase: "Увеличение скорости на уровень",
  jump_and_physics: "Прыжок и физика",
  jump_force: "Сила прыжка",
  max_jump_height: "Максимальная высота прыжка",
  lanes_settings: "Настройки полос",
  number_of_lanes: "Количество полос",
  starting_lane: "Начальная полоса",
  enemies_spawn: "Появление врагов",
  traps_spawn: "Появление ловушек",
  min_spawn_interval_ms: "Минимальный интервал появления (мс)",
  max_spawn_interval_ms: "Максимальный интервал появления (мс)",
  same_lane_chance: "Вероятность появления в той же полосе",
  probability_of_spawn_in_player_lane: "Вероятность появления в полосе игрока",
  collision_tolerance_px: "Допуск столкновения (пикс)",
  scoring_rules: "Правила начисления очков",
  hit_penalty: "Штраф за столкновение",
  powerup_reward: "Награда за усиление",
  score_speed_divider: "Делитель очков по скорости",
  reset_combo_on_hit: "Сброс комбо при столкновении",
  camera_settings: "Настройки камеры",
  normal_zoom: "Обычный зум",
  hit_zoom: "Зум при столкновении",
  zoom_lerp_speed: "Скорость сглаживания зума",
  game_end_conditions: "Условия окончания игры",
  phone_dialog_score_threshold: "Порог очков для диалога телефона",

  // 8. Вкладка Цвета (TabColors)
  background_gradient: "Градиент фона",
  first_color: "Первый цвет",
  second_color: "Второй цвет",
  particle_hit_color: "Цвет частиц столкновения",
  particle_powerup_color: "Цвет частиц усиления",
  main_background_color: "Основной цвет фона",
  ground_color: "Цвет земли",
  hud_colors: "Цвета HUD",
  hud_background: "Фон HUD",
  score_text_color: "Цвет текста очков",
  level_text_color: "Цвет текста уровня",
  combo_text_color: "Цвет текста комбо",
  overlay_colors: "Цвета наложения",
  backdrop_color: "Цвет задника",
  card_background: "Фон карточки",
  card_border_color: "Цвет рамки карточки",
  explosion_particle_color: "Цвет частиц взрыва",

  // 9. Компонент предпросмотра QR (previewerQr)
  gif_tab: "Вкладка GIF",
  game_tab: "Вкладка игры",
  welcome_gif_upload: "Загрузить приветственный GIF",
  default_welcome: "Приветствие по умолчанию",
  loading_animation: "Анимация загрузки",
  hide_previewer: "Скрыть предпросмотр",
  show_previewer: "Показать предпросмотр",
  edit_game_settings: "Редактировать настройки игры",
  save_and_close: "Сохранить и закрыть",
  animation_scale: "Масштаб анимации",
  animation_slide_x: "Горизонтальное скольжение анимации",
  animation_slide_y: "Вертикальное скольжение анимации",
  animation_fade: "Анимация затухания",
  game_settings_saved: "Настройки игры сохранены",
  no_game_configured: "Игра не настроена",

  // 10. Выборщик GIF (gifSelector)
  gallery_name: "Название галереи",
  change_gallery_name: "Изменить название галереи",
  add_gif: "Добавить GIF",
  select_gif: "Выбрать GIF",
  show_gif: "Показать GIF",
  selected_gif: "Выбранный GIF",
  count: "Количество",
  select_category: "Выбрать категорию",
  after_typing_enter: "После ввода нажмите Enter",
  search: "Поиск",
  no_gif_available: "Нет доступных GIF",
  to_use_ready_gifs_search_category_or_product:
    "Для использования готовых GIF ищите по категории или продукту",
  max_file_size_2mb: "Максимальный размер файла 2 МБ",
  upload_file: "Загрузить файл",
  drag_and_drop_to_upload_or: "Перетащите файл или",
  here: "здесь",
  click: "нажмите",
  all: "Все",
  no_gif_found: "GIF не найден",
  for_adding_file_use_upload_center:
    "Для добавления файла используйте центр загрузки",
  to_use_external_gif_link_fill_fields:
    "Для использования внешней ссылки на GIF заполните поля",
  gif_url_hint: "Полный URL файла GIF",
  gif_url: "URL GIF",
  add: "Добавить",
  title: "Название",
  link: "Ссылка",
  description: "Описание",
  add_new_gallery: "Добавить новую галерею",
  enter_valid_link: "Введите действительную ссылку",
  create_gif: "Создать GIF",
  ready_gifs: "Готовые GIF",
  gif_gallery: "Галерея GIF",
  edit_gif: "Редактировать GIF",
  max_background_gif_size_2mb: "Максимальный размер фонового GIF 2 МБ",
  uploaded_successfully: "Успешно загружено",
  gif_upload_error: "Ошибка загрузки GIF",

  // 11. Дополнительные тексты и тестовые ключи
  preview: "Предпросмотр",
  start_button_text: "Текст кнопки старта",
  game_over_text: "Текст окончания игры",
  game_over_subtext: "Подтекст окончания игры",
  mobile_prompt_text: "Текст запроса мобильного",
  submit_button_text: "Текст кнопки отправки",
  optional: "Опционально",
  game_background: "Фон игры",
  background_gradient_colors: "Цвета градиента фона",
  frames_per_enemy: "Кадров на врага",
  frames_per_powerup: "Кадров на усиление",
  win_threshold: "Порог победы",
  score_to_win: "Очки для победы",
  your_work_page_name: "Личный/Корпоративный Кивар",
  "pdf_gallery": {
    "display_mode": "Режим отображения галереи PDF",
    "display_mode_label": "Режим отображения",
    "layout": {
      "list": "Список",
      "accordion": "Аккордеон",
      "slider": "Слайдер"
    },
    "gallery_name": "Имя галереи",
    "selected_gallery": "Выбранная галерея",
    "add_file": "Добавить файл",
    "pdf_gallery_label": "Галерея PDF",
    "select_file": "Выбрать файл",
    "title": "Заголовок",
    "pdf_url": "URL-адрес PDF",
    "description": "Описание",
    "add_button": "Добавить",
    "all": "Все",
    "image_gallery": "Галерея изображений",
    "edit_pdf": "Редактировать PDF",
    "preview": "Предпросмотр",
    "add_pdf_gallery": "Добавить галерею PDF",
    "default_gallery_name": "Галерея",
    "gallery_prefix": "Галерея",
    "tabs": {
      "add_file": "Добавить файл",
      "pdf_gallery": "Галерея PDF",
      "link": "Ссылка"
    },
    "messages": {
      "file_too_large": "Размер файла не может превышать 10 МБ.",
      "invalid_file_type": "Пожалуйста, выбирайте только документы и текстовые файлы.",
      "upload_error": "Ошибка при загрузке файла.",
      "only_pdf_txt_allowed": "Можно добавлять только файлы PDF и TXT.",
      "title_url_required": "Пожалуйста, введите заголовок и URL файла."
    }
  },
  "special_info_desc": {
    "textCards": "Добавьте текстовые карточки для отображения информации о пользователе или краткой биографии.",
    "customerClubSettings": "Установите сообщение о членстве в клубе клиентов, отправляемое после регистрации номера.",
    "advanceSettings": "Управляйте расширенными и умными настройками для персонализации страницы.",
    "voiceGallery": "Загружайте и управляйте аудиофайлами для воспроизведения на странице.",
    "VideoGallery": "Добавляйте и отображайте видео для представления или обучения.",
    "imageUploader": "Загружайте изображения для отображения в галерее или в разных частях страницы.",
    "colorPallete": "Выберите цвета для настройки дизайна и внешнего вида страницы.",
    "socialMediaIcons": "Добавьте ссылки на социальные сети для быстрого доступа.",
    "pdfSelector": "Загружайте и отображайте файлы PDF для пользователей.",
    "FeedBack": "Получайте комментарии и отзывы пользователей об услугах.",
    "consultationNew": "Создайте форму для отправки запросов или связи с пользователями."
  },
  "voice_gallery": {
    "autoplay_warning": "Вы можете настроить автовоспроизведение только для одного аудиофайла.",
    "autoplay": "Автовоспроизведение"
  },
  "card": {
    "consultation": {
      "title": "Форма запроса"
    },
    "form": {
      "name": "Имя",
      "surname": "Фамилия",
      "phone": "Номер мобильного",
      "email": "Эл. почта",
      "address": "Адрес",
      "national_id": "Национальный ID",
      "location": "Местоположение",
      "description": "Описание"
    },
    "feedback": {
      "title": "Ваш отзыв",
      "description": "Пожалуйста, помогите нам улучшить наши услуги, ответив на следующие вопросы:",
      "q1": "Насколько вы удовлетворены услугами QRLand?",
      "q2": "В какой степени услуги QRLand покрыли ваши потребности?",
      "q3": "Насколько разумной была стоимость полученной услуги?",
      "q4": "Поделитесь с нами своими мыслями, чтобы улучшить наши услуги."
    },
    "pdf": {
      "gallery_name": "Галерея предложений QRLand",
      "item1_title": "Предложение по внедрению продукта",
      "item1_desc": "Комплексное введение в услуги QRLand, как работают умные QR-коды и преимущества для бизнеса.",
      "item2_title": "Предложение цифровой визитки",
      "item2_desc": "Введение в цифровую визитку QRLand, быстрый обмен контактной информацией и социальные сети."
    },
    "pdf_selector": {
      "title": "Галерея PDF",
      "description": "Описание"
    },
    "info": {
      "visit_name": "QRLand / Цифровая визитка",
      "organization_name": "QRLand",
      "sub_organ": "Первая платформа динамической генерации QR-кодов",
      "user_name": "Цифровая визитка",
      "fax": "Факс: 02191016066",
      "location_desc": "г. Тегеран, ул. Шариати, после моста Сейед Хандан, переулок Хандан, № 6",
      "postal_code": "Почтовый индекс: 1541946815",
      "about_us": "Из-за проблем с физическими визитками платформа QRLand представила продукт «Цифровая визитка». Используя цифровые технологии, она полностью устранила ограничения и предотвращает вырубку деревьев.",
      "full_address": "Иран, провинция Тегеран, Тегеран, район 3, Сейед Хандан, д-р Али Шариати, Хандан"
    },
    "extra": {
      "field1": "🟥 Создайте аналогичную цифровую визитку для своего бизнеса.\n🟧 Тестируйте ее бесплатно 3 дня.\n🟨 Нажмите здесь, чтобы зарегистрироваться бесплатно.",
      "field2": "Ваша цифровая визитка имеет динамический QR-код. Вы можете редактировать информацию в любое время через мобильный телефон. Ваш QR-код никогда не изменится после редактирования.",
      "field3": "💲 Стоимость этой визитной карточки составляет 900 000 томанов."
    },
    "gallery": {
      "name": "Мы всегда будем рядом с вами..."
    },
    "social": {
      "address_hint": "Пожалуйста, введите ваш адрес",
      "address_label": "Адрес",
      "instagram_hint": "Пожалуйста, введите ваш URL-адрес в Instagram",
      "instagram_label": "Instagram",
      "whatsapp_hint": "Пожалуйста, введите ваш URL-адрес в WhatsApp",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "Почему визитка QRLand? В чем отличие QRLand?",
      "item1_title": "Почему визитка QRLand",
      "item2_name": "Введение в цифровую визитку QRLand",
      "item2_title": "Лучшая альтернатива физическим визиткам"
    },
    "club": {
      "title": "Членство в клубе клиентов",
      "description": "Это не обычный клуб клиентов!\nЗарегистрируйте свой номер"
    },
    "audio": {
      "category_all": "Все",
      "item1_title": "Комплексное руководство по цифровым визиткам",
      "diff_seconds": "1 секунду назад"
    }
  },
  "pic": {
    "background_image": "Фоновое изображение",
    "image_display_type": "Тип отображения изображения",
    "image_orientation": "Ориентация изображения:",
    "horizontal": "Горизонтально",
    "vertical": "Вертикально",
    "change_display_mode": "Изменить режим отображения",
    "image": "Изображение",
    "uploaded_image": "Загруженное изображение"
  },
    "send_limit_per_user": "Лимит отправки на пользователя (0 = безлимитно)",
    "enable_discount_code": "Активировать промокод",
    "add_new_discount_code": "Добавить новый промокод",
    "no_discount_codes_added": "Промокоды не добавлены",
"toolsManagment": "Инструменты управления",
"gateway": {
  "edit": "Редактировать",
  "integrated_edit_all_sections": "Интегрированное редактирование всех разделов",
  "show_descriptions": "Показать описания",
  "search_section_placeholder": "Поиск раздела...",
  "no_section_found": "Раздел с таким именем не найден.",
  "back_to_menu": "Назад в меню",
  "cancel": "Отмена",
  "save": "Сохранить"
},
"gridShow": "Сетка",
"tableShow": "Таблица",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "Добавляйте текстовые карточки для отображения информации о пользователе, например описания, опыта или краткого представления.",

    customer_club_settings_description:
      "Настройте сообщение о вступлении в клуб клиентов, которое отправляется пользователям после регистрации номера телефона.",

    advance_settings_description:
      "Управляйте расширенными и интеллектуальными настройками для персонализации поведения и возможностей страницы.",

    voice_gallery_description:
      "Загружайте и управляйте аудиофайлами для воспроизведения на странице.",

    video_gallery_description:
      "Добавляйте и отображайте видео для презентации, обучения или демонстрации контента.",

    image_uploader_description:
      "Загружайте изображения для отображения в галерее или различных разделах страницы.",

    color_palette_description:
      "Выбирайте пользовательские цвета для персонализации внешнего вида и дизайна страницы.",

    social_media_icons_description:
      "Добавляйте ссылки на социальные сети для быстрого доступа.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "Загрузите или измените основное изображение баннера комплекса.",

    logo_select_description:
      "Настройте логотип компании или комплекса.",

    service_description:
      "Управляйте основными услугами и возможностями комплекса.",

    faq_description:
      "Добавляйте и редактируйте часто задаваемые вопросы клиентов.",

    blog_description:
      "Добавляйте статьи и новости о комплексе.",

    floor_description:
      "Управляйте этажами и торговыми помещениями комплекса.",

    text_cards_description:
      "Введите описание и информацию, связанную с пользователем.",

    social_media_icons_description:
      "Добавляйте ссылки на социальные сети для связи с клиентами.",

    pic_selector_description:
      "Добавляйте изображения комплекса и магазинов.",

    video_gallery_description:
      "Загружайте презентационные или рекламные видео.",

    pdf_selector_description:
      "Управляйте каталогами и информационными файлами.",

    feedback_description:
      "Управляйте разделом отзывов и обратной связи посетителей.",

    consultation_new_description:
      "Управляйте формой для сбора информации или запросов клиентов.",

    service_section_description:
      "Создавайте отдельные разделы для услуг.",

    counter_service_description:
      "Отображайте статистику и достижения комплекса в числовом формате.",

    counter_description:
      "Настройте обратный отсчёт до мероприятий или открытия.",

    personnel_description:
      "Представьте руководителей и ключевых участников команды.",

    customer_club_settings_description:
      "Управляйте настройками SMS и регистрации в клубе клиентов.",

    work_sheet_description:
      "Укажите рабочие часы и дни работы комплекса.",

    pallet_commercial_description:
      "Настройте цвета и визуальный стиль страницы.",

    default_description:
      "Добавьте и управляйте разделом {title} на странице компании.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "Настройте страницу входа и измените логотип магазина.",

  banner_selector_description:
    "Загружайте и управляйте баннерами магазина.",

  text_cards_description:
    "Текстовая информация, представление и информация о компании.",

  product_description:
    "Создавайте, управляйте и редактируйте товары.",

  special_category_manager_description:
    "Управляйте категориями специальных предложений и товаров со скидкой.",

  social_media_icons_description:
    "Добавляйте ссылки на социальные сети магазина.",

  blog_description:
    "Пишите и управляйте публикациями в блоге.",

  service_description:
    "Представляйте дополнительные предоставляемые услуги.",

  faq_description:
    "Отображайте и управляйте списком часто задаваемых вопросов.",

  pic_selector_description:
    "Загружайте и управляйте галереей изображений магазина.",

  video_gallery_description:
    "Загружайте презентационные и рекламные видео.",

  pdf_selector_description:
    "Предоставляйте инструкции или PDF-каталоги.",

  feedback_description:
    "Управляйте отзывами и обратной связью клиентов.",

  counter_description:
    "Настройте обратный отсчёт до мероприятий или специальных предложений.",

  consultation_description:
    "Создайте форму для получения запросов или заявок на консультацию.",

  service_section_description:
    "Управляйте отдельными разделами услуг.",

  counter_service_description:
    "Отображайте статистику, показатели и достижения магазина.",

  personnel_description:
    "Представляйте членов команды и сотрудников магазина.",

  work_sheet_description:
    "Настройте рабочие дни и часы работы магазина.",

  default_description:
    "Добавьте и управляйте разделом {title} на странице магазина.",
},
edit_gold_special_info_single: {
  product_info_title: "Информация о товаре",
  product_info_description:
    "Добавление и редактирование основных характеристик товара, его свойств, цены и дополнительного описания.",

  asset_management_title: "Управление активами",
  asset_management_description:
    "Управление активами, назначение стоимости и информацией о кошельке, связанной с товаром.",

  add_social_networks_title: "Добавить социальные сети",
  social_networks_title: "Социальные сети",
  social_media_description:
    "Добавьте ссылки на социальные сети для более быстрого взаимодействия клиентов с вашим брендом.",

  add_video_title: "Добавить видео",
  video_description:
    "Добавляйте и отображайте презентационные, обучающие или рекламные видео товара.",

  add_image_title: "Добавить изображение",
  image_description:
    "Загружайте качественные изображения товара с разных ракурсов для лучшего отображения в галерее.",

  select_color_title: "Выбрать цвет",
  color_palette_description:
    "Настройте цветовую палитру и внешний вид страницы товара в соответствии с фирменным стилем.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "Редактирование имени, фотографии профиля и фона",

  management_account_description:
    "Добавление и редактирование данных банковских счетов",

  management_color_description:
    "Изменение цветовой темы кнопок и фона",
},

edit_feedback_special_single: {
  base_info_description:
    "Редактирование основной информации и заголовка формы",

  image_uploader_description:
    "Загрузка и управление логотипом формы обратной связи",

  feedback_description:
    "Настройка полей и управление формой обратной связи",

  color_palette_description:
    "Выбор цветовой темы и настройка внешнего вида формы",
},

edit_gitf_special_info_single: {
  default_description:
    "Добавление и управление разделом {title} в QR-рамке воспоминаний.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "Основная информация, заголовок и описание каталога",

  image_uploader_description:
    "Загрузка и управление логотипом или основным изображением",

  pic_selector_description:
    "Загрузка и управление страницами каталога или брошюры",

  social_media_icons_description:
    "Добавление и управление ссылками на социальные сети",

  color_palette_description:
    "Выбор цветовой темы и настройка внешнего вида",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "Выберите шаблон для применения другой категоризации",

  login_config_description:
    "Настройки и внешний вид страницы входа",

  general_settings_description:
    "Общие настройки валюты и типа бизнеса.",

  banner_selector_description:
    "Загрузите и выберите баннер, который будет отображаться в верхней части страницы и сделает меню или профиль более привлекательным.",

  product_description:
    "Создавайте и управляйте товарами или услугами с такими деталями, как изображение, цена и индивидуальное описание.",

  text_cards_description:
    "Добавляйте текстовые карточки для отображения основной информации о пользователе, например общего описания, опыта или краткого представления.",

  social_media_description:
    "Добавляйте ссылки и значки социальных сетей для более быстрого общения и удобного доступа клиентов.",

  photo_gallery_description:
    "Создайте галерею изображений для отображения фотографий товаров, примеров работ или интерьера бизнеса.",

  video_gallery_description:
    "Добавьте видеогалерею для отображения рекламных роликов, обучающих или презентационных видео.",

  feedback_description:
    "Создайте раздел для отображения отзывов, обратной связи и уровня удовлетворённости предыдущих клиентов.",

  working_hours_description:
    "Укажите рабочие часы и время работы бизнеса.",
},

edit_pdf_special_info_single: {
  base_info_title: "Информация",
  base_info_description:
    "Добавляйте текстовые карточки для отображения основной информации о пользователе, например общего описания, опыта или краткого представления.",

  image_uploader_title: "Загрузить логотип",
  image_uploader_description:
    "Загрузите и выберите изображение в качестве логотипа или фотографии профиля для отображения на странице.",

  pdf_selector_title: "Добавить PDF-галерею",
  pdf_selector_description:
    "Создайте галерею PDF- или текстовых файлов с возможностью добавления обложки и индивидуального описания для каждого файла.",

  social_media_icons_title: "Добавить социальные сети",
  social_media_icons_description:
    "Добавляйте ссылки и значки социальных сетей для более быстрой связи и удобного доступа.",

  color_palette_title: "Выбрать цвет",
  color_palette_description:
    "Выберите цвет шаблона и настройте внешний вид элементов в соответствии с вашим брендом.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "Добавление и управление разделом {title} в фотогалерее.",
},

edi_social_special_info_single: {
  banner_selector_title: "Загрузить фото",
  banner_selector_description:
    "Выберите и загрузите фоновое изображение или баннер в верхней части вашей страницы социальной сети.",

  base_info_title: "Информация",
  base_info_description:
    "Введите основную информацию, например главный заголовок и описание профиля.",

  image_uploader_title: "Загрузить логотип",
  image_uploader_description:
    "Загрузите личный логотип, логотип бренда или изображение профиля для отображения на странице.",

  social_media_icons_title: "Добавить социальные сети",
  social_media_icons_description:
    "Добавьте ссылки на Instagram, Telegram, WhatsApp, LinkedIn и другие социальные сети, чтобы их значки отображались на странице.",
},

edit_text_special_info_single: {
  base_info_title: "QR-информация и тексты",
  base_info_subtitle: "Основной текст и текстовые поля",
  base_info_description:
    "Редактирование заголовка, основного текста «О нас» и пользовательских текстовых полей QR",

  image_uploader_title: "Логотип и фоновое изображение",
  image_uploader_subtitle: "Настройки изображения",
  image_uploader_description:
    "Загрузка и изменение пользовательского логотипа или фонового изображения карточки",

  color_palette_subtitle: "Настройка внешнего вида",
  color_palette_description:
    "Настройка цветов заголовка, фона и текста для улучшения читаемости и контрастности",
},

edit_video_special_info_single: {
  base_info_title: "Информация",
  base_info_description:
    "Редактирование основной информации, например заголовка и адреса QR-кода.",

  image_uploader_title: "Загрузить логотип",
  image_uploader_description:
    "Загрузка и управление изображением логотипа страницы.",

  video_gallery_title: "Видеогалерея",
  video_gallery_description:
    "Добавление, редактирование и управление видео для отображения в галерее.",

  social_media_icons_title: "Добавить социальные сети",
  social_media_icons_description:
    "Добавление ссылок на социальные сети и способов связи.",

  color_palette_title: "Выбрать цвет",
  color_palette_description:
    "Изменение цветовой схемы и выбор подходящей цветовой темы для страницы.",
},

edit_product_special_info_single: {
  factory_info_description:
    "Редактирование информации и представления компании",

  single_product_editor_description:
    "Редактирование основных данных и кнопок действия, например «Купить»",

  customer_club_settings_description:
    "Настройки клуба клиентов и отправка SMS",

  advance_settings_description:
    "Расширенные настройки отображения и безопасности",

  features_description:
    "Управление характеристиками и техническими параметрами товара",

  voice_gallery_description:
    "Загрузка и управление подкастами и аудиофайлами",

  image_uploader_description:
    "Загрузка и управление галереей изображений товара",

  video_gallery_description:
    "Добавление и управление галереей связанных видео",

  social_media_icons_description:
    "Добавление и управление ссылками на социальные сети",

  color_palette_description:
    "Выбор цветовой темы и настройка шаблона",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "Введите общую информацию и представление производственной компании.",

  single_product_editor_description:
    "Настройте основную информацию, значок доверия и кнопку покупки товара.",

  customer_club_settings_description:
    "Настройки SMS и членства клиентов в клубе.",

  features_description:
    "Добавьте характеристики и технические параметры товара.",

  feedback_description:
    "Раздел отзывов и обратной связи покупателей.",

  consultation_description:
    "Форма запроса консультации или оформления заказа.",

  advance_settings_description:
    "Расширенные и интеллектуальные настройки отображения товара.",

  voice_gallery_description:
    "Аудиофайлы для презентации или инструкции по товару.",

  image_uploader_description:
    "Загрузите различные изображения товара.",

  video_gallery_description:
    "Презентационные или обучающие видео, связанные с товаром.",

  social_media_icons_description:
    "Ссылки на социальные сети для дополнительного общения.",

  color_palette_description:
    "Настройте цвета и визуальный стиль страницы товара.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "Основная информация и характеристики аудиогалереи",

  image_uploader_description:
    "Загрузка и управление логотипом или обложкой",

  voice_gallery_description:
    "Загрузка и управление аудиофайлами и подкастами",

  color_palette_description:
    "Выбор цветовой темы и настройка внешнего вида галереи",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "Редактирование заголовка и описания галереи",

  image_uploader_description:
    "Загрузка и управление логотипом и основной обложкой",

  voice_gallery_acc_description:
    "Загрузка, удаление и управление аудиофайлами",

  social_media_icons_description:
    "Добавление и управление ссылками на социальные сети",

  color_palette_description:
    "Выбор цветовой темы и настройка внешнего вида галереи",
},
edit_bpage_special_info_special: {
  advertising_sites: "Рекламные сайты",
stores: "Магазины",

divar: "Divar",
divar_hint: "Введите ссылку на Divar",

sheypoor: "Sheypoor",
sheypoor_hint: "Введите ссылку на Sheypoor",

digikala: "Digikala",
digikala_hint: "Введите ссылку на Digikala",

basalam: "Basalam",
basalam_hint: "Введите ссылку на Basalam",

snappshop: "SnappShop",
snappshop_hint: "Введите ссылку на SnappShop",

technolife: "Technolife",
technolife_hint: "Введите ссылку на Technolife",

torob: "Torob",
torob_hint: "Введите ссылку на Torob",

emalls: "eMalls",
emalls_hint: "Введите ссылку на eMalls",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "Введите ссылку на Cafe Bazaar",

googleplay: "Google Play",
googleplay_hint: "Введите ссылку на Google Play",

samsung: "Samsung",
samsung_hint: "Введите ссылку на Galaxy Store",

apple: "Apple",
apple_hint: "Введите ссылку на App Store",
  add_audio_gallery: "Добавить галерею аудиофайлов",
  factory_information: "Информация об организации",
  trust_badge: "Знак доверия",
  buy_button: "Кнопка покупки",
  smart_settings: "Интеллектуальные настройки",
  add_product_feature: "Добавить характеристику товара",
  product_features: "Характеристики товара",
  add_audio_file: "Добавить аудиофайл",
  audio_gallery: "Аудиогалерея",
  text: "Текст",
  logo_background: "Логотип / фон",
  select_color: "Выбрать цвет",
  information: "Информация",
  luck_management: "Управление удачей",
  registration_management: "Управление регистрацией",
  turning: "Перелистывание",
  slider: "Слайдер",
  vertical: "Вертикальный",
  upload_catalog_brochure_images: "Загрузить изображения каталога / брошюры",
  upload_banner: "Загрузить баннер",
  upload_header_image: "Загрузить изображение заголовка",
  upload_image: "Загрузить изображение",
  services: "Услуги",
  faq: "Часто задаваемые вопросы",
  blog: "Блог",
  create_product: "Создать товар",
  user_information: "Информация о пользователе",
  add_social_media: "Добавить социальные сети",
  photo_gallery: "Фотогалерея",
  video_gallery: "Видеогалерея",
  pdf_gallery: "PDF-галерея",
  feedback: "Обратная связь",
  request_form: "Форма запроса",
  create_section: "Создать раздел",
  achievements: "Достижения",
  countdown: "Обратный отсчёт",
  team_members: "Члены команды",
  working_hours: "Рабочее время",
  upload_logo: "Загрузить логотип",
  create_store: "Создать магазин",
  customer_club_membership_sms: "SMS о вступлении в клуб клиентов",
  product_information: "Информация о товаре",
  asset_management: "Управление ресурсами",
  social_media: "Социальные сети",
  add_video: "Добавить видео",
  add_image: "Добавить изображение",
  add_user_information: "Добавить информацию о пользователе",
  manage_accounts: "Управление аккаунтами",
  manage_color: "Управление цветами",
  download_qr: "Скачать QR-код",
  add_store: "Добавить магазин",
  manage_appointments: "Управление записями",
},
edit_gift_special_info_special: {
  gift_story: "История подарка",
  profile_image: "Изображение профиля",
  featured_images: "Избранные изображения",
  image_gallery: "Галерея изображений",
  video_gallery: "Видеогалерея",
  add_audio_file: "Добавить аудиофайл",
  select_color: "Выбрать цвет",
},
edit_insurance_special_info_special: {
  login_settings: "Настройки входа",
  shop_logo_images: "Логотип и изображения магазина",
  login_page_information: "Информация страницы входа",
  upload_banner_logo: "Загрузить баннер и логотип",
  user_information: "Информация о пользователе",
  manage_products_insurance: "Управление товарами / страхованием",
  special_sale: "Специальные предложения",
  add_social_media: "Добавить социальные сети",
  blog: "Блог",
  services: "Услуги",
  faq: "Часто задаваемые вопросы",
  photo_gallery: "Фотогалерея",
  video_gallery: "Видеогалерея",
  pdf_gallery: "PDF-галерея",
  feedback: "Обратная связь",
  countdown: "Обратный отсчёт",
  request_form: "Форма запроса",
  create_section: "Создать раздел",
  achievements: "Достижения",
  team_members: "Члены команды",
  working_hours: "Рабочее время",
  shop_login_description: "Настройки логотипа и страницы входа в магазин",
  insurance_manage_description: "Добавление и редактирование списка товаров / услуг",
  banner_description: "Управление изображениями заголовка",
},
  };
